import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message, Dimmer, Loader } from 'semantic-ui-react'
// import _find from 'lodash/find';
import _ from 'lodash';

//utils
import queries from '../../../utils/queries'

import SeguroPermite from '../../../components/funcionales/seguropermite'

import ListaDe from '../../../components/funcionales/dirmayor/listade';
import ListaCi from '../../../components/funcionales/dirmayor/listaci';
import ListaZo from '../../../components/funcionales/dirmayor/listazo';
import selDirmayor from '../../../functions/seldirmayor';
// import selciudad from '../../../functions/selciudad';

// "use strict";

function getNumDiasMes(mesDias, agnoDias){
  /*
      Los meses 1,3,5,7,8,10,12 siempre tienen 31 días
      Los meses 4,6,9,11 siempre tienen 30 días
      El mes de febrero dependiendo del año puede tener 28 o 29 días
  */
  let mes = parseInt(mesDias, 10)
  let agno = parseInt(agnoDias, 10)

  if( (mes === 1) || (mes === 3) || (mes === 5) || (mes === 7) || (mes === 8) || (mes === 10) || (mes === 12) ) 
    return 31;
  else if( (mes === 4) || (mes === 6) || (mes === 9) || (mes === 11) ) 
    return 30;
  else if( mes === 2 )
  {
      if((agno % 4 === 0) && ((agno % 100 !== 0) || (agno % 400 === 0)))
        return 29;
      else
        return 28;
  }   
}

//dropdown CLASES
const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.codigoClaseServ} value={props.elemento._id} style={props.styles.input}>{props.elemento.descrClaseServ}</option>
  )
};

const Lista = ({styles, handleLista3, list,  argsSelDpto}) => {
    const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
    return(
        <div>
            <select style={styles.input} className="ui simple selection dropdown fluid" name="clase" id="miLista2" onChange={handleLista3}>
                <option style={styles.input} value="">Todas...</option>
                {Nivel1Detalle}
            </select>
        </div>
    )
};
//Fin dropdown CLASES

//dropdown RANGOS FACTURACION
const DetalleRangoNivel1 = props => {
  return (
    <option dato1={props.elemento._id} dato2={props.elemento.prefijo} value={props.elemento.proxFact+':'+props.elemento.factInicial+':'+props.elemento.factFinal} style={props.styles.input}>{props.elemento.prefijo} {props.elemento.factInicial} - {props.elemento.factFinal}</option>
  )
};

const ListaRango = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleRangoNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  // let selecc = true
  // if(list.length===1){
  //   selecc = false
  // }
  return(
    // <div>
    //   {selecc  &&
    //     <select style={styles.input} className="ui simple selection dropdown fluid" name="rango" id="miLista3" onChange={(ev)=>handleChange(ev)}>
    //       <option value="">Seleccionar...</option>
    //       {Nivel1Detalle}
    //     </select>
    //   }
    //   {!selecc  &&
    //     <select style={styles.input} className="ui simple selection dropdown fluid" name="rango" id="miLista3">
    //       {Nivel1Detalle}
    //     </select>
    //   }
    // </div>
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="rango" id="miLista3" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown RANGOS DE FACTURACION

//dropdown CICLOS FACTURACION
const DetalleCF1 = props => {
  return (
    <option dato1={props.elemento._id} dato2={props.elemento.noFactRET.toString()} value={props.elemento.cicloFact} style={props.styles.input}>{props.elemento.cicloFact}</option>
  )
};

const ListaCF = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleCF1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="cicloFact" id="miListaCF" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown CICLOS DE FACTURACION

//Progreso del proceso de facturación
const ProcesoFact = ({styles, progresoFact, finProceso}) => {
  let titProgreso = "Procesando ..."
  let titProgreso1 = "Seleccionando los clientes a facturar "
  return(
    <div>
      {progresoFact>0&&finProceso===0 &&
        <div>
          <div>
            <div className='ui segment'>
              <Dimmer active  style={{background: '#7F7FD5'}}>
                <Loader style={{color: '#302b63'}} indeterminate>Proceso de facturación en progreso ...</Loader>
              </Dimmer>
              <img src='images/progreso.png' alt="En progreso"/>
              </div>
          </div>

          <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
              {titProgreso}<br/>
          </p>
          {progresoFact===1 &&
            <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0em'}}>
              &nbsp;&nbsp;{titProgreso1}<br/>
            </p>
          }
        </div>
      }
    </div>
  )
};
//Fin progreso del proceso de facturación

const argsBuscarMC = {procesado: "N"}
const argsBuscarCCF = {procesado: "S", agno: "1964", mes: "15"}

// const fechaHoy = new Date()
// let agnoHoy = fechaHoy.getFullYear()
// let mesHoy = ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1))
let agnoHoy = "2017"
let mesHoy = "03"

let argsBuscarMCNeg = {tipoqry: `[{$match: {tipo: 'X'}},{$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}}]`}

//noFactRET: "false" => entre comillas porque en DetalleCF1 dato2 no acepta Boolean
class FactProcFact2 extends React.Component {
  state={argsDocum: {_id: "", mes: "",  fechaFact: "", factInicial: "", factFinal: "", pagueHasta: "",
        observaciones: "", prefijoFact: "", proxFact: "", rango: "Seleccionar...",
        cicloFact: "Seleccionar...", noFactRET: "false", checkNoFactMPF: true},
        argsSelDpto: this.props.argsSelDpto, opciones: "Imagen 1",
        permiteUpdate: true, confirmaAct: false, open: false, errors: [], progresoFact: 0, finProceso: 0}

  handleChange = (ev) => {
    // console.log(ev.target.name)
    // console.log(ev.target.value)
    // console.log(ev.target)
    let cargoClientes = true
    if(!this.props.allClientes.allClientes){
      cargoClientes = false
    }
//     if(ev.target.name === "cicloFact"){
// console.log(ev.target.value)
//     }
    // const argsDocum = this.state.argsDocum
    if(ev.target.name === "rango"&&cargoClientes){
      let argsDocum = this.state.argsDocum
      
      let miLista = document.getElementById("miLista3");
      let _id = miLista.options[miLista.selectedIndex].attributes[0].value?miLista.options[miLista.selectedIndex].attributes[0].value:""
      argsDocum['_id'] = _id
      let prefijoFact = miLista.options[miLista.selectedIndex].attributes[1].value?miLista.options[miLista.selectedIndex].attributes[1].value:""
      if(prefijoFact.indexOf(":")!==-1){
        prefijoFact=""
      }
      argsDocum['prefijoFact'] = prefijoFact
      argsDocum[ev.target.name] = ev.target.value
      let posic1 = ev.target.value.indexOf(":")
      let proxFact = parseInt(ev.target.value.substr(0, posic1), 10) + 1
      let factInFin = ev.target.value.substr(posic1 + 1)
      posic1 = factInFin.indexOf(":")
      let factInicial = factInFin.substr(0, posic1)
      let factFinal = factInFin.substr(posic1 + 1)

      if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
        argsDocum['proxFact'] = (prefijoFact?prefijoFact+"-"+proxFact:proxFact).toString()
      }else{
        argsDocum['proxFact'] = ""
      }
      argsDocum['factInicial'] = factInicial
      argsDocum['factFinal'] = factFinal

      this.setState({argsDocum});
      this.setState({progresoFact: 0, finProceso: 0})
      // console.log(argsDocum)
    }
    if(ev.target.name === "prefijoFact"){
      let argsDocum = this.state.argsDocum
      // console.log(argsDocum.proxFact)
      let posic1 = argsDocum.proxFact.indexOf("-")
      if(posic1!==-1){
        argsDocum['proxFact'] = argsDocum.proxFact.substr(posic1 + 1)
      }else{
        // argsDocum['proxFact'] = argsDocum.proxFact
      }
      argsDocum['proxFact'] = ev.target.value?ev.target.value+"-"+argsDocum.proxFact:argsDocum.proxFact
      argsDocum[ev.target.name] = ev.target.value 
      this.setState({argsDocum});
      // console.log(argsDocum)
    }
    if(ev.target.name !== "rango"&&ev.target.name !== "prefijoFact"){
      let argsDocum = this.state.argsDocum
      if(ev.target.name === "checkNoFactMPF"){
        // let argsDocum = this.state.argsDocum
        argsDocum[ev.target.name] = ev.target.checked
        // this.setState({argsDocum});
      }else{
        // if(ev.target.name==="mes"){
        //   let argsBuscarFact={}
        //   argsBuscarFact.agno = ev.target.value.substr(0, 4)
        //   argsBuscarFact.mes = ev.target.value.substr(5, 2)
        //   this.props.allFacturacion.refetch(argsBuscarFact)
        //   this.props.allCargoEsp.refetch(argsBuscarFact)
        // }
        // let argsDocum = this.state.argsDocum
        argsDocum[ev.target.name] = ev.target.value
        if(ev.target.name === "cicloFact"){
          let miLista = document.getElementById("miListaCF");
          // let _idCF = miLista.options[miLista.selectedIndex].attributes[0]?miLista.options[miLista.selectedIndex].attributes[0].value:""
          let noFactRET = miLista.options[miLista.selectedIndex].attributes[1]?miLista.options[miLista.selectedIndex].attributes[1].value:""
          argsDocum["noFactRET"] = noFactRET
          // console.log(noFactRET)
        }
          
        // this.setState({argsDocum});
        // console.log(argsDocum)
      }
      this.setState({argsDocum});
    }
    if(ev.target.name==="opciones"){
      if(ev.target.checked===true){
        this.setState({opciones: ev.target.value})
        // console.log(ev.target.value)
      }
    }
  }

  handleSubmit = async (ev, mesMsg, list, opciones)=>{
    //ACTUALIZAR BD
    async function crudBD(operacionCRUD, args, i) {
      // console.log("CRUD")
            if(args.ctrlCampo === 'CRUD'){
      // console.log(i)
      // console.log(args)
      const {data} = await operacionCRUD({
        variables: args
      });

      //Se utiliza para traer el _id del documento creado
        if(args.ctrl_id === 'SI_ID'){
          if(Object.values(data)[0]._id){
            return Object.values(data)[0]._id
          }else{
            return 0
          }
        }
      }else{
        if(args.ctrlCampo === "MANY"){
          console.log("MANY")
          // console.log(args)
          await operacionCRUD({
            variables: args
          });
        }
      }
    }
  
    //ENVIO PARA ACTUALIZAR BD
    async function updColecc(crudColecc, argsCrud, totDocCRUD) {
      // console.log(argsCrud)
      // console.log(totDocCRUD)
      let codigo = 0
      // console.log(argsCrud)
      if(argsCrud[0].ctrl_id === 'SI_ID'){
        codigo = await crudBD(crudColecc[0], argsCrud[0], 0)
      }else{
        await crudBD(crudColecc[0], argsCrud[0], 0)
      }
      if(codigo!==0){
        for(let i=1; i<totDocCRUD; i++){
          argsCrud[i]._id = codigo
        }
      }
      // console.log("inicio")
      for(let i=1; i<totDocCRUD; i++){
        await crudBD(crudColecc[i], argsCrud[i], i)
      }
      console.log("final")
      // let finProceso = 1
      // return finProceso
    }

    let codProcFact = new Date().getTime();
    codProcFact = codProcFact.toString()
    let proxFact = this.state.argsDocum.proxFact
    let factIniProc = proxFact, factFinProc
    let proxFactR

    // let fechaHoy = new Date()
    // let horaHoy = fechaHoy.getHours()+":"+fechaHoy.getMinutes()+":"+fechaHoy.getSeconds();
    // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
    // if(fechaHoy){
      const response = await this.props.fecha({
        variables: {}
      });
      const {fechaFechaHoy, fechaHoraHoy} = await response.data.fecha
      let fechaHoy = fechaFechaHoy.substr(0,10)
      let horaHoy = fechaHoraHoy.substr(11, 8)
      // console.log(fechaFechaHoy, fechaHoraHoy)
      // console.log(fechaHoy, horaHoy)
    // }else{
    //   console.log("No trajo la fecha hora")
    // }
    // console.log(fechaHoy, horaHoy)
    let argsUpd
    let argsUpdDet
    let errors = []
    if(!this.props.allClientes.allClientes||!this.props.allFacturacion.allFacturacion||
      !this.props.allMovTodos.allMovTodos||!this.props.allMovTodosCC.allMovTodosCC||
      !this.props.allMovTodosCC1.allMovTodosCC){
      errors.push({path: "Cargando", message: "La información se está cargando, por favor espere un momento"});
    }
    // if(!this.props.allClientes.allClientes){
    //   errors.push({path: "Generar", message: "Proceso de cargue de la información, por favor espere un momento..."});
    // }
    if(!this.state.argsDocum.fechaFact){
      errors.push({path: "Fecha Fra", message: "Debe seleccionar la fecha factura"});
    }
    if(!this.state.argsDocum.pagueHasta){
      errors.push({path: "Pague hasta", message: "Debe seleccionar la fecha de pague hasta"});
    }
    if(!this.state.argsDocum.rango||this.state.argsDocum.rango==="Seleccionar..."){
      errors.push({path: "Rango", message: "Debe seleccionar el rango de la numeración de facturación"});
    }
    if(!this.state.argsDocum.proxFact||this.state.argsDocum.prefijoFact+'-'===this.state.argsDocum.proxFact){
      errors.push({path: "Factura", message: "Debe indicarse el número de la próxima factura"});
    }else{
      if(this.props.allFactRtes.allFactRtes){
        let fraCliente = []
        let argsBuscarFactCli = `{'numeroFra': '${this.state.argsDocum.proxFact}'}`
        let tipoqry = `[{$match: ${argsBuscarFactCli}}]`
        argsBuscarFactCli = {tipoqry}
        let {data} = await this.props.allFactRtes.refetch(argsBuscarFactCli)
        fraCliente = await data.allFactRtes
        if(fraCliente.length>0){
          errors.push({path: "Factura", message: "La próxima factura " + this.state.argsDocum.proxFact + " YA existe"});
        }
      }
    }
    if(!this.state.argsDocum.cicloFact||this.state.argsDocum.cicloFact==="Seleccionar..."){
      errors.push({path: "Ciclo", message: "Debe seleccionar el ciclo de facturación"});
    }
    if(!this.state.argsDocum.observaciones){
      errors.push({path: "Observaciones", message: "Debe escribir las observaciones"});
    }

    // console.log(this.state.argsDocum)
    // console.log(mesMsg)
    this.setState({errors})
    if(errors.length===0){
      this.setState({progresoFact: 1})
//Guardar registro del proceso de facturación enviado
console.time(1)
      let minEspera = 0
// console.log("11")
      let argsAdd = {}
      argsAdd['codProcFact'] = codProcFact      
      argsAdd['mes'] = mesMsg
      argsAdd['fechaFact'] = this.state.argsDocum.fechaFact
      argsAdd['factInicial'] = this.state.argsDocum.factInicial
      argsAdd['factFinal'] = this.state.argsDocum.factFinal
      argsAdd['pagueHasta'] = this.state.argsDocum.pagueHasta
      argsAdd['idRangoFact'] = this.state.argsDocum._id
      if(this.state.argsSelDpto.descrDpto&&this.state.argsSelDpto.descrDpto!=="Todos..."){
        argsAdd['descrDpto'] = this.state.argsSelDpto.descrDpto}else{
          argsAdd['descrDpto'] = "Todos los Departamentos"
      }
      if(this.state.argsSelDpto.nombreCiudad&&this.state.argsSelDpto.nombreCiudad!=="Todas..."){
        argsAdd['nombreCiudad'] = this.state.argsSelDpto.nombreCiudad}else{
          argsAdd['nombreCiudad'] = "Todas las Ciudades"
      }
      if(this.props.empresa.empresaArchFE==="sinergy"){
        if(this.state.argsSelDpto.nombreZona&&this.state.argsSelDpto.nombreZona!=="Todas..."){
          argsAdd['nombreZona'] = this.state.argsSelDpto.nombreZona}else{
            argsAdd['nombreZona'] = "Todas las Zonas"
        }
      }
      if(this.state.argsSelDpto.descrClaseServ&&this.state.argsSelDpto.descrClaseServ!=="Todas..."){
        argsAdd['descrClaseServ'] = this.state.argsSelDpto.descrClaseServ}else{
          argsAdd['descrClaseServ'] = "Todas las Clases"
      }
      argsAdd['cicloFact'] = this.state.argsDocum.cicloFact
      argsAdd['observaciones'] = this.state.argsDocum.observaciones
      argsAdd['imagenInf'] = this.state.opciones
      argsAdd['fechaCreate'] = fechaHoy
      // console.log(argsAdd)
      const response = await this.props.createProcFact({
        variables: argsAdd
      });
      // console.log("22")
      const {errors, success} = response.data.createProcFact;
      if (!success){
        this.setState({errorAdd: errors})
      }
// console.log("createProcFact")
      let argsBuscarCL={}

      let movCCFact = []
      if(this.props.allMovTodosCC1.allMovTodosCC){
        let argsBuscarCC = {procesado: "S", agno: mesMsg.substr(0, 4), mes: mesMsg.substr(5, 2)}
        let {data} = await this.props.allMovTodosCC1.refetch(argsBuscarCC)
        movCCFact = await data.allMovTodosCC
      }
      console.log(movCCFact)

      let clienteMNF = []
      if(this.props.allMesNoFra.allMesNoFra){
        let {data} = await this.props.allMesNoFra.refetch({procesado: "N"})
        clienteMNF = await data.allMesNoFra
      }
      // console.log(clienteMNF)

// PARA PRUEBAS
    // let clientesFra = []
    // argsBuscarCL.numDocum = 2027
    // argsBuscarCL.tipoProc = "Clientes para facturacion"
    // argsBuscarCL.cicloFact = this.state.argsDocum.cicloFact
    // let campos = {_id: 1, contrato: 1, dirmayor: 1, direccion: 1, cicloFact: 1, saldoPendiente: 1,
    //   totPagoAdelSinFrar: 1, porcFact: 1,
    //   estadoCliente: 1, nombreCliente: 1, apellidoCliente: 1, numeroDoc: 1, eMail: 1, fechaPrimeraActivacion: 1,
    //   tarifa: 1, oferta: 1}

    // if(this.props.allClientes.allClientes){
    //   // console.log(argsBuscarCL)
    //   let {data} = await this.props.allClientes.refetch(argsBuscarCL, campos)
    // console.log(data.allClientes)
    //   // let {data} = await this.props.allClientes.refetch(argsBuscarCL)
    //   clientesFra = await data.allClientes
    //   clientesFra = await clientesFra.filter(elemento => 
    //     elemento.contrato==="19695"||elemento.contrato==="151840"||elemento.contrato==="41109"||elemento.contrato==="150981")
    // }
    // // console.log("clientesFra")   
    // // console.log(clientesFra)
    // // console.log(this.props.allFacturacion.allFacturacion)
    // // console.log(this.props.allClientes.allClientes)
    // // let clientesFra = []
    // if(!this.state.argsSelDpto.descrDpto||this.state.argsSelDpto.descrDpto==="Todos..."){
    //   // // clientesFra = this.props.allClientes.allClientes
    //   // clientesFra = clientesFra.filter(elemento => 
    //   //   elemento.cicloFact===this.state.argsDocum.cicloFact)
    // }else{
    //   if(!this.state.argsSelDpto.nombreCiudad||this.state.argsSelDpto.nombreCiudad==="Todas..."){
    //     // clientesFra = clientesFra.filter(elemento => 
    //     //   elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto&&
    //     //   elemento.cicloFact===this.state.argsDocum.cicloFact)
    //     clientesFra = clientesFra.filter(elemento => 
    //       elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto)
    //   }else{
    //     // clientesFra = clientesFra.filter(elemento => 
    //     //   elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto&&
    //     //   elemento.dirmayor.ciudades.nombreCiudad===this.state.argsSelDpto.nombreCiudad&&
    //     //   elemento.cicloFact===this.state.argsDocum.cicloFact)
    //     clientesFra = clientesFra.filter(elemento => 
    //       elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto&&
    //       elemento.dirmayor.ciudades.nombreCiudad===this.state.argsSelDpto.nombreCiudad)
    //   }
    // }
//FIN PARA PRUEBAS

    //PROCESO DE FACTURACION
    //Seleccionar clientes del dpto y ciudad seleccionados
      let fraMesCliente = [], fraMesCliente1 = []
      let argsBuscarFact={}
      argsBuscarFact.agno = mesMsg.substr(0, 4)
      argsBuscarFact.mes = mesMsg.substr(5, 2)
      if(this.props.allFacturacion.allFacturacion){
        let {data} = await this.props.allFacturacion.refetch(argsBuscarFact)
        fraMesCliente = await data.allFacturacion

        let agnoSig = parseInt(mesMsg.substr(0, 4), 10)
        let mesSig = parseInt(mesMsg.substr(5, 2), 10) + 1
        if(mesSig.toString()==='13'){
          agnoSig=agnoSig+1
          mesSig='01'
        }else{
          mesSig = (mesSig<10?'0'+mesSig:mesSig)
        }
        let periodo = mesMsg.substr(0, 4) + "-" + mesMsg.substr(5, 2)
        let argsBuscarFact1 = `{'agno': '${agnoSig}', 'mes': '${mesSig}', 'detalleFact.periodo': '${periodo}'}`
        let tipoqry = `[{$match: ${argsBuscarFact1}}]`
        argsBuscarFact1 = {tipoqry}
        if(argsBuscarFact1){
          let {data} = await this.props.allFactRtes.refetch(argsBuscarFact1)
          fraMesCliente1 = await data.allFactRtes
        }
        fraMesCliente = fraMesCliente.concat(fraMesCliente1)
        fraMesCliente1 = []
      }

// console.log(this.props.allFacturacion.allFacturacion)
console.log(fraMesCliente)
// console.log(argsBuscarFact)
// console.log("argsBuscarFact")
      let ceMesCliente = [], ceMesCliente1 = []
      let argsBuscarCE={}
      argsBuscarCE.agno = mesMsg.substr(0, 4)
      argsBuscarCE.mes = mesMsg.substr(5, 2)
      if(this.props.allCargoEsp.allCargoEsp){
        let {data} = await this.props.allCargoEsp.refetch(argsBuscarCE)
        ceMesCliente = await data.allCargoEsp
      }
// console.log(ceMesCliente)

//PARA PROCESO
      let clientesFra = []
      argsBuscarCL.numDocum = 2027
      argsBuscarCL.tipoProc = "Clientes para facturacion"
      argsBuscarCL.cicloFact = this.state.argsDocum.cicloFact
      let campos = {_id: 1, contrato: 1, dirmayor: 1, direccion: 1, cicloFact: 1, saldoPendiente: 1,
        totPagoAdelSinFrar: 1, porcFact: 1,
        estadoCliente: 1, nombreCliente: 1, apellidoCliente: 1, numeroDoc: 1, eMail: 1, fechaPrimeraActivacion: 1,
        tarifa: 1, oferta: 1}

      if(this.props.allClientes.allClientes){
        // console.log(argsBuscarCL)
        let {data} = await this.props.allClientes.refetch(argsBuscarCL, campos)
console.log(data.allClientes.length)
        // let {data} = await this.props.allClientes.refetch(argsBuscarCL)
        clientesFra = await data.allClientes
      }
      // console.log("clientesFra")   
// console.log(clientesFra)
// console.log(this.props.allFacturacion.allFacturacion)
// console.log(this.props.allClientes.allClientes)
      // let clientesFra = []
      if(!this.state.argsSelDpto.descrDpto||this.state.argsSelDpto.descrDpto==="Todos..."){
        // // clientesFra = this.props.allClientes.allClientes
        // clientesFra = clientesFra.filter(elemento => 
        //   elemento.cicloFact===this.state.argsDocum.cicloFact)
      }else{
        if(!this.state.argsSelDpto.nombreCiudad||this.state.argsSelDpto.nombreCiudad==="Todas..."){
          // clientesFra = clientesFra.filter(elemento => 
          //   elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto&&
          //   elemento.cicloFact===this.state.argsDocum.cicloFact)
          clientesFra = clientesFra.filter(elemento => 
            elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto)
        }else{
          if(!this.state.argsSelDpto.nombreZona||this.state.argsSelDpto.nombreZona==="Todas..."){
            // clientesFra = clientesFra.filter(elemento => 
            //   elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto&&
            //   elemento.dirmayor.ciudades.nombreCiudad===this.state.argsSelDpto.nombreCiudad&&
            //   elemento.cicloFact===this.state.argsDocum.cicloFact)
            clientesFra = clientesFra.filter(elemento => 
              elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto&&
              elemento.dirmayor.ciudades.nombreCiudad===this.state.argsSelDpto.nombreCiudad)
          }else{
            clientesFra = clientesFra.filter(elemento =>
              elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto&&
              elemento.dirmayor.ciudades.nombreCiudad===this.state.argsSelDpto.nombreCiudad&&
              elemento.dirmayor.ciudades.zonas.nombreZona===this.state.argsSelDpto.nombreZona)
          }
        }
      }
      //FIN PARA PROCESO

      //OJOOOOO REVISAR QUE LOS CLIENTES NO TENGAN TARIFAS QUE SI TENGAN IMPTOS PERO ESTEN NULL
      // console.log(this.props.allFacturacion.allFacturacion)
      // console.log(this.props.allClientes.allClientes)
      // console.log(clientesFra)

      await this.props.allClientes.refetch({numDocum: 1})
      // console.log(this.props.allClientes.allClientes)

      //ORDENAR POR BARRIO + DIRECCION
      let clientesFra1 = clientesFra.map(cliente => ({...cliente}))
      clientesFra.forEach(async (elemento, _id) => {
        let linea1DNN = ""
        if(elemento.direccion.descrTipoVia1){
          linea1DNN = elemento.direccion.descrTipoVia1?elemento.direccion.descrTipoVia1:""
          linea1DNN += elemento.direccion.numeroTipoVia1?" " + elemento.direccion.numeroTipoVia1:""
          linea1DNN += elemento.direccion.descrTipoVia2?" " + elemento.direccion.descrTipoVia2:""
          linea1DNN += elemento.direccion.numeroTipoVia2?" " + elemento.direccion.numeroTipoVia2:""
          linea1DNN += elemento.direccion.numeroTipoVia2F?" " + elemento.direccion.numeroTipoVia2F:""
          linea1DNN += elemento.direccion.descrTipoUnd1?" " + elemento.direccion.descrTipoUnd1:""
          linea1DNN += elemento.direccion.numeroTipoUnd1?" " + elemento.direccion.numeroTipoUnd1:""
          linea1DNN += elemento.direccion.descrTipoUnd2?" " + elemento.direccion.descrTipoUnd2:""
          linea1DNN += elemento.direccion.numeroTipoUnd2?" " + elemento.direccion.numeroTipoUnd2:""
        }
        const indexLis = clientesFra1.findIndex(cliente => cliente._id === elemento._id);
        clientesFra1[indexLis].direccionFra = linea1DNN
        clientesFra1[indexLis].nombreBarrio = elemento.nombreBarrio
      })
      clientesFra = clientesFra1.map(cliente => ({...cliente}))

      let origen = "MES " + mesMsg
      // const indexSearch = listMovCli.findIndex( &&elementoMC.&&elementoMC.periodo===periodoFrado )

      let listMovCli = []
      // console.log(this.props.allMovClientes.allMovClientes)
      // console.log(origen, mesMsg.substr(0, 4), mesMsg.substr(5, 2))
      if(this.props.allMovClientes.allMovClientes){
        // console.log("11")
        await this.props.allMovClientes.refetch({origen: origen, agno: mesMsg.substr(0, 4), mes: mesMsg.substr(5, 2), numeroFra: "", valorTotal: {$gt: 0}})
        // console.log("22")
        listMovCli = await this.props.allMovClientes.allMovClientes
        // console.log(listMovCli)
      }
      // console.log(listMovCli)
      clientesFra = _.orderBy(clientesFra, ['nombreBarrio', 'direccionFra'], ['asc', 'asc'])
      //FIN ORDENAR POR BARRIO + DIRECCION
      // console.log("ordenado clientesFra")
      minEspera = parseInt((clientesFra.length * 30), 10)
      // console.log(minEspera)
      let tieneRegMovCli = false, tieneRegMovCliCC = false
      let creaFraMany = [], movCliMany = [], actmovCliMany = [], actCliMany = [], actCliPHMany = [],
      actPASFCliMany = [], actCliMCMany = [], creaHC = [], actMNFMany = []

      console.log(clientesFra.length)
      clientesFra.forEach(async (elemento, _id) => {
        // for(let i=1; i<clientesFra.length; i++){
        //   let elemento = clientesFra[i]

        // let listMovCli = []
        // if(this.props.allMovClientes.allMovClientes){
        //   await this.props.allMovClientes.refetch({contrato: elemento.contrato})
        //   listMovCli = await this.props.allMovClientes.allMovClientes
        // }

        // if(elemento.contrato==="99"){
        //   console.log(elemento)
        // }
        //tieneRegMovCliCCMA es para cuando el cliente tenga en movcliccs documento con periodo = NO FACTURAR
        let tieneRegMovCliCCMA = false
        let saldoCl = elemento.saldoPendiente
        let saldoClIni = elemento.saldoPendiente
        let saldoAnterior = elemento.saldoPendiente
        let totPagoAdelSinFrar = elemento.totPagoAdelSinFrar
        let  porcFact  = elemento.porcFact
        // if(elemento.contrato==="16074"){
        //   console.log(elemento.contrato, saldoAnterior)
        // }
  
        let valorAntesImptos = 0, valorFacturado = 0
        let valorAntesImptosCC = 0, valorFacturadoCC = 0

        let movCli=[], movCliI=[], movFras=[], creaFra=[], actmovCli=[], actCliMC=[], actMNF = []

        // console.log(elemento)
        //Revisar si el cliente tiene movimientos sin facturar

        //FACTURAR MOVIMIENTOS NO FACTURADOS

        //SELECCIONAR MOVIMIENTOS SIN FACTURAR, DE LA CLASE SELECCIONADA
        // let movContrato = []
        let movContratoCC = []
        if(!this.state.argsSelDpto.descrClaseServ||this.state.argsSelDpto.descrClaseServ==="Todas..."){
          // movContrato = this.props.allMovTodos.allMovTodos.filter(elemento1 => 
          //   elemento1.contrato===elemento.contrato&&elemento1.procesado==="N")

          movContratoCC = this.props.allMovTodosCC.allMovTodosCC.filter(elemento1 => 
            elemento1.contrato===elemento.contrato&&elemento1.procesado==="N")
        }else{
          // movContrato = this.props.allMovTodos.allMovTodos.filter(elemento1 => 
          //   elemento1.contrato===elemento.contrato&&
          //   elemento1.descrClaseServ===this.state.argsSelDpto.descrClaseServ&&
          //   elemento1.procesado==="N")

          movContratoCC = this.props.allMovTodosCC.allMovTodosCC.filter(elemento1 => 
            elemento1.contrato===elemento.contrato&&
            elemento1.descrClaseServ===this.state.argsSelDpto.descrClaseServ&&
            elemento1.procesado==="N")
        }
        // console.log(this.props.allMovTodos.allMovTodos)
        // console.log(movContrato)
        // console.log("651", movContratoCC)
        let listServDetFra = [], listServDetFraCC = [], groupListaCC = [];
        //         movContrato.forEach((elemento1, _id) => {
        //           console.log("entroooooooooooooooooooooo")
        //           alert("OJOOO POR AQUI NO DEBE ENTRAR")
        // // if(elemento.contrato==="91848"){
        // //   console.log(this.state.argsDocum.checkNoFactMPF, elemento1.periodo.substr(0,7), mesMsg)
        // // }
        // //SI SE ESTA FACTURANDO UN MES ANTERIOR => EL DOCUM SE DEJA COMO procesado = N
        // //se revisa si el documento es de un mes anterior o igual al mes fact o si viene con periodo = NO FACTURAR
        //           if(!this.state.argsDocum.checkNoFactMPF||(this.state.argsDocum.checkNoFactMPF&&
        //             (elemento1.periodo.substr(0,7)<=mesMsg||elemento1.periodo==="NO FACTURAR"))){
        // //si viene con periodo NO FACTURAR y el documento es del mes que se factura =>
        // //se marca con tieneRegMovCliCCMA = true => no factura el mes y el documento deja procesado = S
        //               if(elemento1.periodo==="NO FACTURAR"&&(elemento1.agno + "-" + elemento1.mes)===mesMsg){
        //                 // console.log("tiene MA ", elemento1.periodo, mesMsg, elemento1.agno, elemento1.mes)
        //                 tieneRegMovCliCCMA = true
        //               }
    
              
          //           tieneRegMovCli = true
          // // console.log(elemento1)
          //           if(elemento1.procesado==="N"&&elemento1.subTipo!=="CE"){
          // // console.log(elemento1.procesado)
          // // console.log(elemento1.subTipo)
          // //CREAR DETALLE FACT Y ACTUALIZAR movclientes CON EL CONCEPTO Y EL NUMFRA
          //             const valorServ = elemento1.valorTotal
          //             const valorAntesI = elemento1.valorAntesImptos
          //             if(valorServ!==0||elemento1.periodo==="NO FACTURAR"){
          //               // saldoCl += valorServ
          //               valorAntesImptos += valorAntesI
          //               valorFacturado += valorServ
          //               saldoAnterior -= valorServ
          //               // if(elemento.contrato==="16074"){
          //               //   console.log(elemento.contrato, saldoAnterior)
          //               // }
                
          //               listServDetFra.push({codigoServicio: elemento1.codigoServicio, nombreResumido: elemento1.nombreResumido,
          //                 descripcionServicio: elemento1.descripcionServicio, descrClaseServ: elemento1.descrClaseServ,
          //                 numeroCE: elemento1.numeroCE, numeroRC: elemento1.numeroRC, valorPagado: elemento1.valorPagado,
          //                 valorPendiente: elemento1.valorPendiente, fechaUltPago: elemento1.fechaUltPago, valorUltPago: elemento1.valorUltPago,
          //                 numeroOdeDX: elemento1.numeroOdeDX, valorServicios: valorServ, imptos: elemento1.imptos,
          //                 agnoFra: mesMsg.substr(0, 4), mesFra: mesMsg.substr(5, 2), fechaCargo: this.state.argsDocum.fechaFact,
          //                 periodoFrado: elemento1.periodo, valorAntesImptos: valorAntesI, agno: elemento1.agno, mes: elemento1.mes,
          //                 origenCC: "movContrato", _id: elemento1._id
          //               });
          //             }
          //           }else{
          // // console.log(elemento1.procesado)
          // // console.log(elemento1.subTipo)
          //             if(elemento1.procesado==="N"&&elemento1.subTipo==="CE"&&elemento1.documento!=="ANULADO"){
          //               saldoAnterior += elemento1.valorTotal
          //               // if(elemento.contrato==="16074"){
          //               //   console.log(elemento.contrato, saldoAnterior)
          //               //   console.log(elemento1)
          //               // }
          //             }
          //           }
          //         }
          //         })
          //MOVIMIENTOS cuando en parametros comoAsigCargosAlCliente = Hacer los cargos al cliente en el proceso de facturación
          const numDiasMes = getNumDiasMes(mesMsg.substr(5, 2), mesMsg.substr(0, 4))
          movContratoCC.forEach((elemento1, _id) => {
            // if(elemento.contrato==="91848"){
            //   console.log(this.state.argsDocum.checkNoFactMPF, elemento1.periodo.substr(0,7), mesMsg)
            // }
            //SI SE ESTA FACTURANDO UN MES ANTERIOR => EL DOCUM SE DEJA COMO procesado = N
            //se revisa si el documento es de un mes anterior o igual al mes fact o si viene con periodo = NO FACTURAR
            if(!this.state.argsDocum.checkNoFactMPF||(this.state.argsDocum.checkNoFactMPF&&
              (elemento1.periodo.substr(0,7)<=mesMsg||elemento1.periodo==="NO FACTURAR"))){
                //si viene con periodo NO FACTURAR y el documento es del mes que se factura =>
                //se marca con tieneRegMovCliCCMA = true => no factura el mes y el documento deja procesado = S
                if(elemento1.periodo==="NO FACTURAR"&&(elemento1.agno + "-" + elemento1.mes)===mesMsg){
                  // console.log("tiene MA ", elemento1.periodo, mesMsg, elemento1.agno, elemento1.mes)
                  tieneRegMovCliCCMA = true
                }

                tieneRegMovCliCC = true
                // console.log(elemento1)
                if(elemento1.procesado==="N"&&elemento1.subTipo!=="CE"){
                  // console.log(elemento1.procesado)
                  // console.log(elemento1.subTipo)
                  //CREAR DETALLE FACT Y ACTUALIZAR movclientes CON EL CONCEPTO Y EL NUMFRA
                  const valorServ = elemento1.valorTotal
                  const valorAntesI = elemento1.valorAntesImptos
                  if(valorServ!==0||elemento1.periodo==="NO FACTURAR"){
                    // console.log("11", valorServ, elemento1.periodo)
                    // saldoCl += valorServ
                    valorAntesImptos += valorAntesI
                    valorFacturado += valorServ
                    valorAntesImptosCC += valorAntesI
                    valorFacturadoCC += valorServ

                    // saldoAnterior -= valorServ
                    // if(elemento.contrato==="16074"){
                    //   console.log(elemento.contrato, saldoAnterior)
                    // }

                    listServDetFra.push({codigoServicio: elemento1.codigoServicio, nombreResumido: elemento1.nombreResumido,
                      descripcionServicio: elemento1.descripcionServicio, descrClaseServ: elemento1.descrClaseServ,
                      concepto: elemento1.concepto,
                      velEfecDownstream: elemento1.velEfecDownstream, velEfecUpstream: elemento1.velEfecUpstream,
                      codigoTipoTec: elemento1.codigoTipoTec, descrTipoTec: elemento1.descrTipoTec,
                      numeroCE: elemento1.numeroCE, numeroRC: elemento1.numeroRC, valorPagado: elemento1.valorPagado,
                      fechaUltPago: elemento1.fechaUltPago, valorUltPago: elemento1.valorUltPago,
                      numeroOdeDX: elemento1.numeroOdeDX, valorServicios: valorServ, imptos: elemento1.imptos,
                      agnoFra: mesMsg.substr(0, 4), mesFra: mesMsg.substr(5, 2), fechaCargo: this.state.argsDocum.fechaFact,
                      periodoFrado: elemento1.periodo, valorAntesImptos: valorAntesI, agno: elemento1.agno, mes: elemento1.mes,
                      origenCC: "movContratoCC", _id: elemento1._id
                    });

                    listServDetFraCC.push({codigoServicio: elemento1.codigoServicio, nombreResumido: elemento1.nombreResumido,
                      descripcionServicio: elemento1.descripcionServicio, descrClaseServ: elemento1.descrClaseServ,
                      concepto: elemento1.concepto,
                      velEfecDownstream: elemento1.velEfecDownstream, velEfecUpstream: elemento1.velEfecUpstream,
                      codigoTipoTec: elemento1.codigoTipoTec, descrTipoTec: elemento1.descrTipoTec,
                      numeroCE: elemento1.numeroCE, numeroRC: elemento1.numeroRC, valorPagado: elemento1.valorPagado,
                      fechaUltPago: elemento1.fechaUltPago, valorUltPago: elemento1.valorUltPago,
                      numeroOdeDX: elemento1.numeroOdeDX, valorServicios: valorServ, imptos: elemento1.imptos,
                      agnoFra: mesMsg.substr(0, 4), mesFra: mesMsg.substr(5, 2), fechaCargo: this.state.argsDocum.fechaFact,
                      periodoFrado: elemento1.periodo, valorAntesImptos: valorAntesI, agno: elemento1.agno, mes: elemento1.mes,
                      numDiasAFactSinOf: numDiasMes, numDiasAFactConOf: 0, porcDctoOferta: 0,
                      origenCC: "movContratoCC", _id: elemento1._id
                    });

                  }
                }else{
                  // console.log(elemento1.procesado)
                  // console.log(elemento1.subTipo)
                  if(elemento1.procesado==="N"&&elemento1.subTipo==="CE"&&elemento1.documento!=="ANULADO"){
                    // saldoAnterior += elemento1.valorTotal
                    // if(elemento.contrato==="16074"){
                    //   console.log(elemento.contrato, saldoAnterior)
                    //   console.log(elemento1)
                    // }
                  }
                }
              }
            })
            //FIN MOVIMIENTOS cuando en parametros comoAsigCargosAlCliente = Hacer los cargos al cliente en el proceso de facturación

            let valorSinFra = valorFacturado - valorFacturadoCC
            let linea1DNN = ""
            if(elemento.direccion.descrTipoVia1){
              linea1DNN = elemento.direccion.descrTipoVia1?elemento.direccion.descrTipoVia1:""
              linea1DNN += elemento.direccion.numeroTipoVia1?" " + elemento.direccion.numeroTipoVia1:""
              linea1DNN += elemento.direccion.descrTipoVia2?" " + elemento.direccion.descrTipoVia2:""
              linea1DNN += elemento.direccion.numeroTipoVia2?" " + elemento.direccion.numeroTipoVia2:""
              linea1DNN += elemento.direccion.numeroTipoVia2F?" " + elemento.direccion.numeroTipoVia2F:""
              linea1DNN += elemento.direccion.descrTipoUnd1?" " + elemento.direccion.descrTipoUnd1:""
              linea1DNN += elemento.direccion.numeroTipoUnd1?" " + elemento.direccion.numeroTipoUnd1:""
              linea1DNN += elemento.direccion.descrTipoUnd2?" " + elemento.direccion.descrTipoUnd2:""
              linea1DNN += elemento.direccion.numeroTipoUnd2?" " + elemento.direccion.numeroTipoUnd2:""
            }

            // console.log(listServDetFra)
            // console.log("800", listServDetFraCC)
            // console.log(valorFacturado)
            // if(valorFacturado!==0||tieneRegMovCliCCMA){
            if(valorFacturado!==0||listServDetFra.length>0||listServDetFraCC.length>0){
              if(elemento.estadoCliente!=="ACTIVO"&&valorFacturado>0){
                // console.log(elemento.contrato, saldoAnterior, valorFacturado)
                argsUpd = {
                  "codProcFact": codProcFact,
                  "idRangoFact": this.state.argsDocum._id,
                  "tipoGen": "proceso",
                  "numeroFra": proxFact,
                  "fechaFact": this.state.argsDocum.fechaFact,
                  "contrato": elemento.contrato,
                  "pagueHasta": this.state.argsDocum.pagueHasta,
                  "direccion": linea1DNN,
                  "descrDpto": elemento.dirmayor.descrDpto,
                  "codigoDptoDANE": elemento.dirmayor.codigoDptoDANE,
                  "nombreCiudad": elemento.dirmayor.ciudades.nombreCiudad,
                  "codigoMunicipioDANE": elemento.dirmayor.ciudades.codigoMunicipioDANE,
                  "codigoPostalDANE": elemento.dirmayor.ciudades.codigoPostalDANE,
                  "codigoCiudadInterno": elemento.dirmayor.ciudades.codigoCiudadInterno,
                  "codBarrasRdo": elemento.dirmayor.ciudades.codBarrasRdo,
                  "nombreZona": elemento.dirmayor.ciudades.zonas.nombreZona,
                  "nombreBarrio": elemento.dirmayor.ciudades.zonas.barrios.nombreBarrio,
                  "nombreCliente": elemento.nombreCliente,
                  "apellidoCliente": elemento.apellidoCliente,
                  "numeroDoc": elemento.numeroDoc,
                  "eMail": elemento.eMail,
                  "fechaMov": fechaHoy,
                  "valorAntesImptos": valorAntesImptos,
                  "valorFacturado": valorFacturado,
                  "valorFactura": saldoAnterior + valorFacturado,
                  "agno": mesMsg.substr(0, 4),
                  "mes": mesMsg.substr(5, 2),
                  "numeroDocum": elemento.dirmayor.ciudades.zonas.barrios.numeroDocumR,
                  "descrRecurso": elemento.dirmayor.ciudades.zonas.barrios.descrRecursoR,
                  "usuarioCreate": sessionStorage.getItem('userLogin'),
                  "fechaCreate": fechaHoraHoy,
                };
                creaFra.push(argsUpd)
                // if(elemento.contrato==="TTT53"){
                  // console.log(elemento.contrato, argsUpd)
                // }
              }

              //Crear array con el detallado de los movimientos incluyendo impuestos
              let listServCargoFra = [];
              let numS = new Date().getTime();
              listServDetFra.forEach((elemento2, i) => {
                // console.log(elemento2)
                // if(elemento2.valorAntesImptos!==0||tieneRegMovCliCCMA){
                  listServCargoFra.push({codigoServicio: elemento2.codigoServicio, concepto: elemento2.descripcionServicio,
                                      porcImpto: 0, tipo: "SF", agno: elemento2.agno, mes: elemento2.mes});
                  // }

                elemento2.imptos.forEach((elemento1, ii) => {
                  if(elemento1.codigoImpto!==null){
                    numS = numS + ii + 1
                    listServCargoFra.push({codigoServicio: elemento2.codigoServicio, concepto: elemento1.descrImpto,
                      porcImpto: elemento1.porcImpto, tipo: "IF", agno: elemento2.agno, mes: elemento2.mes});
                  }
                })
              })

              let listServCargoFraCC = [];
              let numSCC = new Date().getTime();
              listServDetFraCC.forEach((elemento2, i) => {
                // console.log(elemento2)            
                // if(elemento2.valorAntesImptos!==0||tieneRegMovCliCCMA){
                  listServCargoFraCC.push({codigoServicio: elemento2.codigoServicio, concepto: elemento2.descripcionServicio,
                                      porcImpto: 0, tipo: "SF", agno: elemento2.agno, mes: elemento2.mes});
                // }

                elemento2.imptos.forEach((elemento1, ii) => {
                  if(elemento1.codigoImpto!==null){
                    numSCC = numSCC + ii + 1
                    listServCargoFraCC.push({codigoServicio: elemento2.codigoServicio, concepto: elemento1.descrImpto,
                      porcImpto: elemento1.porcImpto, tipo: "IF", agno: elemento2.agno, mes: elemento2.mes});
                  }
                })
              })
              groupListaCC = _.uniqWith(listServCargoFraCC, _.isEqual);
              // console.log(groupListaCC)
              // console.log(listServCargoFra)
              // console.log(listServCargoFraCC)
              //AGRUPAR LOS MOVIMIENTOS DEL MISMO SERVICIO Y TOTALIZAR
              const groupLista = _.uniqWith(listServCargoFra, _.isEqual);
              // console.log(groupLista, listServDetFra)
              groupLista.forEach((elemento1, ii) => {
                let servicioFra = this.props.allServicios.allServicios.filter(servicio => servicio.codigoServicio === elemento1.codigoServicio)
                let conceptoEnFra = ""
                // console.log(elemento1)
                let consecEnFra = -1
                if(servicioFra.length>0){
                  conceptoEnFra = servicioFra[0].conceptoEnFra
                  consecEnFra = servicioFra[0].consecEnFra
                }else{
                  conceptoEnFra = elemento1.concepto
                  consecEnFra = 9
                }
                
                let valorAntesI = 0, valorImpto = 0
                let nombreRes = "", descrServ = "", descrClase = "", descrImpto = "", porcImpto = 0
                let velEfecDownstream = 0, velEfecUpstream = 0
                let codigoTipoTec = "", descrTipoTec = ""
                listServDetFra.forEach((elemento2, _id) => {
                  if(elemento2.codigoServicio===elemento1.codigoServicio&&
                    elemento2.descripcionServicio===elemento1.concepto&&elemento1.tipo==="SF"&&
                    elemento2.agno===elemento1.agno&&elemento2.mes===elemento1.mes){
                      // console.log(elemento2, elemento1.tipo)

                      nombreRes = elemento2.nombreResumido
                      descrServ = elemento2.descripcionServicio
                      descrClase = elemento2.descrClaseServ
                      velEfecDownstream = elemento2.velEfecDownstream
                      velEfecUpstream = elemento2.velEfecUpstream
                      codigoTipoTec = elemento2.codigoTipoTec
                      descrTipoTec = elemento2.descrTipoTec
                      if(elemento2.codigoServicio==="CPTO1"||elemento2.codigoServicio==="CPTO2"||elemento2.codigoServicio==="CPTO3"){
                        conceptoEnFra = elemento2.descripcionServicio
                        consecEnFra = 9
                      }

                      valorAntesI += elemento2.valorAntesImptos
                      // console.log("22", elemento2)
                      // console.log(valorAntesI)
                      //Para actualizar concepto y numfra en movclientes
                      argsUpdDet = {
                        "_id": elemento2._id,
                        "numeroFra": proxFact,
                        "numeroCE": elemento2.numeroCE,
                        "numeroRC": elemento2.numeroRC,
                        "concepto": conceptoEnFra,
                        "procesado": "S",
                        "documento": proxFact,
                        "valorPagado": elemento2.valorPagado,
                        "fechaUltPago": elemento2.fechaUltPago,
                        "valorUltPago": elemento2.valorUltPago,
                        "numeroOdeDX": elemento2.numeroOdeDX,
                      }
                      if(elemento2.valorPendiente){
                        argsUpdDet.valorPendiente = elemento2.valorPendiente
                      }
                      // console.log(elemento.contrato, argsUpdDet)
                      actmovCli.push(argsUpdDet)

                      // if(elemento.contrato==="7523"||elemento.contrato==="6138"||elemento.contrato==="6377"||
                      //     elemento.contrato==="15525"){
                        // console.log(elemento.contrato, argsUpdDet)
                      // }              
                      // if(elemento.contrato==="TTT53"){
                      //   console.log(argsUpdDet)
                      // }
                      
                      // console.log(argsUpdDet)
                      let argsUpdPH = {
                        "tipoAct": "EditarCliPagueHasta",
                        "_id": elemento2._id,
                        "pagueHasta": this.state.argsDocum.pagueHasta,
                      }
                      actCliMC.push(argsUpdPH)
                      // console.log(argsUpdPH, elemento2.contrato)
                      }
                      if(elemento2.codigoServicio===elemento1.codigoServicio&&
                          elemento2.agno===elemento1.agno&&elemento2.mes===elemento1.mes){
                        elemento2.imptos.forEach((elemento3, ii) => {
                          // console.log(elemento3)
                          if(elemento3.codigoImpto!==null){
                            if(elemento3.descrImpto===elemento1.concepto&&
                              elemento3.porcImpto===elemento1.porcImpto&&elemento1.tipo==="IF"){
                                nombreRes = elemento2.nombreResumido
                                descrServ = elemento2.descripcionServicio
                                descrClase = elemento2.descrClaseServ
                                velEfecDownstream = elemento2.velEfecDownstream
                                velEfecUpstream = elemento2.velEfecUpstream
                                codigoTipoTec = elemento2.codigoTipoTec
                                descrTipoTec = elemento2.descrTipoTec
                                descrImpto = elemento3.descrImpto
                                porcImpto = elemento3.porcImpto
                                valorImpto += elemento3.valorImpto
                                // console.log(elemento3.porcImpto, elemento3.valorImpto, valorImpto)
                            }
                          }
                        })
                      }
                    })
                    // console.log(valorAntesI)
                    if(valorAntesI!==0){
                      argsUpd = {
                        "codigoServicio": elemento1.codigoServicio,
                        "nombreResumido": nombreRes,
                        "descripcionServicio": descrServ,
                        "descrClaseServ": descrClase,
                        "velEfecDownstream": velEfecDownstream,
                        "velEfecUpstream": velEfecUpstream,
                        "codigoTipoTec": codigoTipoTec,
                        "descrTipoTec": descrTipoTec,
                        "concepto": conceptoEnFra,
                        "periodo": elemento1.agno + '-' + elemento1.mes,
                        "tipo": "SF",
                        "consecEnFra": consecEnFra,
                        "valor": valorAntesI,
                      }
                      movFras.push(argsUpd)

                      // console.log(elemento.contrato, "movFras=>", argsUpd)
                    }
                    // console.log(valorImpto)
                    if(valorImpto!==0){
                      // argsUpdDet = {}
                      argsUpdDet = {
                        // "tipoAct": "CrearDetFra2",
                        // "numeroFra": proxFact,
                        "codigoServicio": elemento1.codigoServicio,
                        "nombreResumido": nombreRes,
                        "descripcionServicio": descrServ,
                        "descrClaseServ": descrClase,
                        "velEfecDownstream": velEfecDownstream,
                        "velEfecUpstream": velEfecUpstream,
                        "codigoTipoTec": codigoTipoTec,
                        "descrTipoTec": descrTipoTec,
                        "concepto": descrImpto,
                        "periodo": elemento1.agno + '-' + elemento1.mes,
                        "tipo": "IF",
                        "consecEnFra": consecEnFra,
                        "porcImpto": porcImpto,
                        "valor": valorImpto,
                      }
                      movFras.push(argsUpdDet)

                      // console.log(elemento.contrato, "movFras=>", argsUpdDet)
                    }
                  })
                  // console.log(movFras)
                  // console.log(creaFra)
                  // console.log(actmovCli)          
                }

                //FIN FACTURAR MOVIMIENTOS NO FACTURADOS
                // console.log(mesMsg)

                // if(elemento.contrato==="7523"||elemento.contrato==="6138"||elemento.contrato==="6377"||
                //     elemento.contrato==="15525"){
                  // console.log(elemento.contrato, movFras, listServDetFra, listServDetFraCC, movContratoCC)
                //   console.log(actmovCli)
                // }

                //FACTURAR EL MES PARA CLIENTES ACTIVOS
                let facturarCli = false
                let listServCargoFra = [];
                if(listServDetFraCC.length>0){
                  //CREAR LOS NUEVOS MOVCLIENTE AGRUPADOS
                  groupListaCC.forEach((elemento1, ii) => {
                    // console.log(elemento1)
                    let servicioFra = this.props.allServicios.allServicios.filter(servicio => servicio.codigoServicio === elemento1.codigoServicio)
                    let conceptoEnFra = "", nombreResumido = "", descripcionServicio = "", descrClaseServ = ""
                    let velEfecDownstream = 0, velEfecUpstream = 0
                    let codigoTipoTec = "", descrTipoTec = ""

                    let consecEnFra = -1
                    if(servicioFra.length>0){
                      conceptoEnFra = servicioFra[0].conceptoEnFra
                      consecEnFra = servicioFra[0].consecEnFra

                      nombreResumido = servicioFra[0].nombreResumido
                      descripcionServicio = servicioFra[0].descripcionServicio
                      descrClaseServ = servicioFra[0].subclaseserv.claseserv.descrClaseServ
                      velEfecDownstream = servicioFra[0].velEfecDownstream
                      velEfecUpstream = servicioFra[0].velEfecUpstream
                      codigoTipoTec = servicioFra[0].codigoTipoTec
                      descrTipoTec = servicioFra[0].descrTipoTec
                    }else{
                      conceptoEnFra = elemento1.concepto
                      consecEnFra = 9
                    }
                    
                    let valorAntesI = 0, valorImpto = 0, valorServ = 0
                    let descrImpto = "", porcImpto = 0
                    let imptosCC = []
                    listServDetFraCC.forEach((elemento2, _id) => {
                      // console.log(elemento2)
                      if(elemento2.codigoServicio===elemento1.codigoServicio&&
                        elemento2.descripcionServicio===elemento1.concepto&&elemento1.tipo==="SF"&&
                        elemento2.agno===elemento1.agno&&elemento2.mes===elemento1.mes){
                          if(elemento2.codigoServicio==="CPTO1"||elemento2.codigoServicio==="CPTO2"||elemento2.codigoServicio==="CPTO3"){
                            conceptoEnFra = elemento2.descripcionServicio
                            consecEnFra = 9
                          }

                          valorAntesI += elemento2.valorAntesImptos
                          valorServ += elemento2.valorServicios
                      }
                      if(elemento2.codigoServicio===elemento1.codigoServicio&&
                        elemento2.agno===elemento1.agno&&elemento2.mes===elemento1.mes){
                        elemento2.imptos.forEach((elemento3, ii) => {
                          if(elemento3.codigoImpto!==null){
                            if(elemento3.descrImpto===elemento1.concepto&&
                              elemento3.porcImpto===elemento1.porcImpto&&elemento1.tipo==="IF"){
                                descrImpto = elemento3.descrImpto
                                porcImpto = elemento3.porcImpto
                                valorImpto += elemento3.valorImpto
                              }
                          }
                        })
                      }
                      if(servicioFra.length===0){
                        // codigoServicio = "OTPACL"
                        if(elemento2.codigoServicio===elemento1.codigoServicio&&
                          elemento2.descripcionServicio===elemento1.concepto){
                            nombreResumido = elemento2.nombreResumido
                            descripcionServicio = elemento2.descripcionServicio
                            descrClaseServ = elemento2.descrClaseServ
                            velEfecDownstream = elemento2.velEfecDownstream
                            velEfecUpstream = elemento2.velEfecUpstream
                            codigoTipoTec = elemento2.codigoTipoTec
                            descrTipoTec = elemento2.descrTipoTec      
                        }  
                      }
                    })

                    if(valorAntesI!==0){
                      argsUpd = {
                        "codigoServicio": elemento1.codigoServicio,
                        "nombreResumido": nombreResumido,
                        "descripcionServicio": descripcionServicio,
                        "descrClaseServ": descrClaseServ,
                        "velEfecDownstream": velEfecDownstream,
                        "velEfecUpstream": velEfecUpstream,
                        "codigoTipoTec": codigoTipoTec,
                        "descrTipoTec": descrTipoTec,
                        "concepto": conceptoEnFra,
                        "periodo": elemento1.agno + '-' + elemento1.mes,
                        "tipo": "SF",
                        "consecEnFra": consecEnFra,
                        "valor": valorAntesI,
                      }
                      imptosCC.push(argsUpd)
                      // console.log(elemento.contrato, argsUpd)
                      let mesF = elemento1.agno + '-' + elemento1.mes
                      if(mesF<mesMsg){facturarCli = true}
                    }

                    if(valorImpto!==0){
                      argsUpdDet = {
                        "codigoServicio": elemento1.codigoServicio,
                        "nombreResumido": nombreResumido,
                        "descripcionServicio": descripcionServicio,
                        "descrClaseServ": descrClaseServ,
                        "velEfecDownstream": velEfecDownstream,
                        "velEfecUpstream": velEfecUpstream,
                        "codigoTipoTec": codigoTipoTec,
                        "descrTipoTec": descrTipoTec,
                        "concepto": descrImpto,
                        "periodo": elemento1.agno + '-' + elemento1.mes,
                        "tipo": "IF",
                        "consecEnFra": consecEnFra,
                        "porcImpto": porcImpto,
                        "valor": valorImpto,
                      }
                      imptosCC.push(argsUpdDet)
                      // console.log(elemento.contrato, argsUpdDet)
                    }

                //Se valida valorServ!==0, porque cuando es = 0 crea registro en movclientes con valortotal = 0
                    if(valorServ!==0){
                      listServCargoFra.push({codigoServicio: elemento1.codigoServicio, nombreResumido: nombreResumido,
                        descripcionServicio: descripcionServicio, descrClaseServ: descrClaseServ,
                        velEfecDownstream: velEfecDownstream, velEfecUpstream: velEfecUpstream,
                        codigoTipoTec: codigoTipoTec, descrTipoTec: descrTipoTec,
                        valorServicios: valorServ, imptos: imptosCC,
                        agnoFra: mesMsg.substr(0, 4), mesFra: mesMsg.substr(5, 2), fechaCargo: this.state.argsDocum.fechaFact,
                        periodoFrado: elemento1.agno + '-' + elemento1.mes, valorAntesImptos: valorAntesI, agno: elemento1.agno, mes: elemento1.mes,
                        numDiasAFactSinOf: numDiasMes, numDiasAFactConOf: 0, porcDctoOferta: 0,
                        origenCC: "movContratoCC", _id: ii + 1000
                      });
                      // console.log(listServCargoFra)
                      // console.log("11")
                    }
                  })
                }

                // if(elemento.contrato==="7523"||elemento.contrato==="6138"||elemento.contrato==="6377"||
                // elemento.contrato==="15525"){
                // console.log(elemento.contrato, listServCargoFra, listServDetFraCC, groupListaCC)
                // }
                //CREAR REGISTROS EN MOVCLIENTES Y DETALLEFACT
                if(tieneRegMovCliCCMA){
                  console.log("tiene mes ant DX", elemento.contrato)
                  facturarCli = false
                }
                if(elemento.fechaPrimeraActivacion){
                  if(elemento.fechaPrimeraActivacion.substr(0, 7)<mesMsg&&!tieneRegMovCliCCMA){facturarCli = true}
                }else{facturarCli = true}
                  if(elemento.estadoCliente==="ACTIVO"&&elemento.tarifa.servicios&&facturarCli){
                    //tener en cuenta vencimiento de tarifa y oferta
                    //Crear registros en movclientes CON TARIFA ACTUAL
                    //Si la tarifa se vence en el mes, facturar con la tarifa actual y actualizar la tarifa al cliente para que
                    //facture el proximo mes con la nueva tarifa
                    // console.log("11")
                    // if(elemento.contrato==="99"){
                    //   console.log(elemento)
                    // }

                  const numDiasMes = getNumDiasMes(mesMsg.substr(5, 2), mesMsg.substr(0, 4))
                  let tieneOferta = false
                  let numDiasAFactSinOf = numDiasMes
                  // if(elemento.oferta.codigoOferta){
                  //   // console.log(elemento.oferta)
                  //   // console.log(elemento.oferta.fechaInicioOferta.substr(0, 7))
                  //   // console.log(mesMsg)
                  //   //Calcular dias a facturar sin oferta porque no ha iniciado la oferta
                  //   if(elemento.oferta.fechaInicioOferta.substr(0, 7)===mesMsg){
                  //     numDiasAFactSinOf = parseInt(elemento.oferta.fechaInicioOferta.substr(8, 2), 10) - 1
                  //     tieneOferta = true
                  //   }else{
                  //     if(elemento.oferta.fechaInicioOferta.substr(0, 7)<mesMsg){
                  //       tieneOferta = true
                  //       numDiasAFactSinOf = 0
                  //     }
                  //   }
                  // }

                  let periodoFrado = mesMsg + '-01 a '
                  periodoFrado += mesMsg + '-' + (numDiasMes<10?'0'+numDiasMes:(numDiasMes))
                  
                  let noFacturar = false

                  // Verificar si tiene mes No facturar
                  // let actMNF = []
                  if(clienteMNF.length>0){
                    const indexMNF = clienteMNF.findIndex(cliente => cliente.contrato===elemento.contrato&&cliente.procesado==='N'&&cliente.agno===mesMsg.substr(0, 4)&&cliente.mes===mesMsg.substr(5, 2));
                    if(indexMNF!==-1){
                      // console.log(clienteMNF[indexMNF])
                      // console.log("MNF", indexMNF, clienteMNF.length, clienteMNF[indexMNF]._id, elemento.contrato, mesMsg.substr(0, 4), mesMsg.substr(5, 2), clienteMNF[indexMNF].observaciones)
                      let argsMNF = {}
                      argsMNF['_id'] = clienteMNF[indexMNF]._id
                      argsMNF['contrato'] = elemento.contrato
                      argsMNF['agno'] = mesMsg.substr(0, 4)
                      argsMNF['mes'] = mesMsg.substr(5, 2)
                      argsMNF['procesado'] = "S"
                      argsMNF['observaciones'] = clienteMNF[indexMNF].observaciones
                      actMNF.push(argsMNF)

                      noFacturar = true
                    }
                  }
                  // FIN Verificar si tiene mes No facturar

                  if(elemento.noFactOSAb&&this.props.empresa.empresaArchFE!=="supercablebq"){
                  // if(elemento.noFactOSAb){
                    noFacturar = true
                  }
                  if(elemento.fechaUltDX&&elemento.fecgaUltRX){
                    let fechaUltDX = elemento.fechaUltDX.substr(0, 10)
                    let fecgaUltRX = elemento.fecgaUltRX.substr(0, 10)
                    let primerDia = mesMsg + '-01'
                    let ultimoDia = mesMsg + '-' + (numDiasMes<10?'0'+numDiasMes:(numDiasMes))
                    // console.log(elemento.contrato, fechaUltDX, fecgaUltRX, primerDia, ultimoDia)
                    if(primerDia>fechaUltDX&&ultimoDia<fecgaUltRX){
                      console.log(elemento.contrato, " => Estaba DX => NO FACTURAR")
                      noFacturar = true
                    }
                  }

                  //Guardar en listServCargoFra los servicios a facturar
                  elemento.tarifa.servicios.forEach((elemento1, i) => {
                    let factServ = true

                    //verificar si es de la clase seleccionada y si esta A (Activo)
                    if((!this.state.argsSelDpto.descrClaseServ||this.state.argsSelDpto.descrClaseServ==="Todas..."||
                    elemento1.subclaseserv.claseserv.descrClaseServ===this.state.argsSelDpto.descrClaseServ)&&
                    elemento1.estadoServicio==="A"){
                      factServ = true
                    }else{
                      factServ = false
                    }

                    if(noFacturar){
                      factServ = false
                    }

                    // if(elemento.contrato==="99"){
                      //   console.log(factServ)
                      //   console.log(mesMsg)
                      // }

                      // if(elemento.contrato==="7523"||elemento.contrato==="6138"||elemento.contrato==="6377"||
                      //     elemento.contrato==="15525"){
                      //   console.log(elemento.contrato, factServ)
                      // }

                    if(factServ){
                      //=>En movimientos no facturados se busca el servicio, si existe, no se factura
                      const indexSearch = movFras.findIndex( servicio => servicio.codigoServicio===elemento1.codigoServicio&&
                                            servicio.periodo===mesMsg )
                      if(indexSearch!==-1){
                        factServ = false}  
                    }

                    // if(elemento.contrato==="7523"||elemento.contrato==="6138"||elemento.contrato==="6377"||
                    //   elemento.contrato==="15525"){
                    //   console.log(elemento.contrato, factServ)
                    // }

                    //=>En facturacion se busca el servicio y mes facturado, si existe, no se factura
                    // if(elemento.contrato==="99"){
                    //   console.log(factServ)
                    // }

                    if(factServ){
                      // console.log("33")
                      // let fraMesCliente = []
                      // let argsBuscarFact={}
                      // argsBuscarFact.contrato = elemento.contrato
                      // argsBuscarFact.agno = mesMsg.substr(0, 4)
                      // argsBuscarFact.mes = mesMsg.substr(5, 2)
                      // if(this.props.allFacturacion.allFacturacion){
                      //   let {data} = await this.props.allFacturacion.refetch(argsBuscarFact)
                      //   fraMesCliente = data.allFacturacion
                      // }
                      fraMesCliente1 = fraMesCliente.filter(factura =>
                        factura.contrato===elemento.contrato)

                    //     if(elemento.contrato==="7523"||elemento.contrato==="6138"||elemento.contrato==="6377"||
                    //     elemento.contrato==="15525"){
                    //   console.log(elemento.contrato, factServ, fraMesCliente1)
                    // }

                    // console.log(fraMesCliente1)
                    // console.log(elemento.contrato)
                    fraMesCliente1.map((elementoFra, i)=>{
                      const indexSearch = elementoFra.detalleFact.findIndex( servicio => servicio.codigoServicio===elemento1.codigoServicio )
                      // console.log(indexSearch)
                      // console.log(elementoFra)
                      // console.log(elemento1.codigoServicio)

                      //     if(elemento.contrato==="7523"||elemento.contrato==="6138"||elemento.contrato==="6377"||
                      //     elemento.contrato==="15525"){
                      //   console.log(elemento.contrato, factServ, indexSearch)
                      // }

                      if(indexSearch!==-1){
                        if(elementoFra.detalleFact[indexSearch].periodo.slice(-5) !== "meses"){
                      //     if(elemento.contrato==="7523"||elemento.contrato==="6138"||elemento.contrato==="6377"||
                      //     elemento.contrato==="15525"){
                      //   console.log(elemento.contrato, factServ, indexSearch)
                      // }
                              factServ = false
                        }
                      }
                      return true
                    })
                  }
                  if(factServ&&listMovCli.length>0){
                    // En los pagos por adelantado se descuenta lo del mes pero no se factura
                    // => hay que controlar que si se vuelve a facturar el contrato no se vuelva a descontar
                    // => si por ej, origen: "MES 2021-04", agno: "2021", mes: "04", numeroFra: "", periodo: "2021-04-01 a 2021-04-30"
                    // =>  ya se habia facturado el mes (sin factura para el caso del pago adelantado) y no debe volverse a facturar
                    // let origen = "MES " + mesMsg
                    // const indexSearch = listMovCli.findIndex( elementoMC => elementoMC.contrato===elemento.contrato&&elementoMC.origen===origen&&elementoMC.agno===mesMsg.substr(0, 4)&&elementoMC.mes===mesMsg.substr(5, 2)&&elementoMC.numeroFra===""&&elementoMC.periodo===periodoFrado )
                    const indexSearch = listMovCli.findIndex( elementoMC => elementoMC.contrato===elemento.contrato&&elementoMC.periodo===periodoFrado )
                    if(indexSearch!==-1){
                      // console.log("control pagos por adelantado", elemento.contrato)
                      factServ = false
                    }
                  }
                        
                  //=>En cargoesp se busca el servicio y mes cargado, si existe, no se carga
                  // if(elemento.contrato==="99"){
                  //   console.log(factServ)
                  // }

                  // if(elemento.contrato==="7523"||elemento.contrato==="6138"||elemento.contrato==="6377"||
                  // elemento.contrato==="15525"){
                  // console.log(elemento.contrato, factServ)
                  // }

                  if(factServ){
                    // console.log("44")
                    // let ceMesCliente = []
                    // let argsBuscarCE={}
                    // argsBuscarCE.contrato = elemento.contrato
                    // argsBuscarCE.agno = mesMsg.substr(0, 4)
                    // argsBuscarCE.mes = mesMsg.substr(5, 2)
                    // if(this.props.allCargoEsp.allCargoEsp){
                    //   let {data} = await this.props.allCargoEsp.refetch(argsBuscarCE)
                    //   ceMesCliente = data.allCargoEsp
                    // }
                    // ceMesCliente = this.props.allCargoEsp.allCargoEsp.filter(cargoesp => cargoesp.contrato===elemento.contrato&&cargoesp.agno===mesMsg.substr(0, 4)&&cargoesp.mes===mesMsg.substr(5, 2))
                    ceMesCliente1 = ceMesCliente.filter(cargoesp => cargoesp.contrato===elemento.contrato)
                    // console.log(ceMesCliente)
                    ceMesCliente1.map((elementoCE, i)=>{
                      const indexSearch = elementoCE.detalleCE.findIndex( servicio => servicio.codigoServicio===elemento1.codigoServicio )
                      if(indexSearch!==-1){factServ = false}
                      return true
                    })
                  }

                  if(factServ){
                    // Si tiene mov procesados en movcliccs del mes a facturar => NO facturar
                    const indexSearch = movCCFact.findIndex( elemento1CC => elemento1CC.contrato===elemento.contrato&&
                      elemento1CC.codigoServicio===elemento1.codigoServicio&&
                      elemento1CC.agno===mesMsg.substr(0, 4)&&elemento1CC.mes===mesMsg.substr(5, 2)&&
                      ((elemento1CC.documento&&elemento1CC.documento!=="NO FACT")||!elemento1CC.documento)&&
                      elemento1CC.procesado==="S" )    
                    if(indexSearch!==-1){
                      factServ = false
                    }
                  }

                  // console.log(factServ)
                  // if(elemento.contrato==="99"){
                  //   console.log(factServ)
                  // }

                  if(factServ){
                    // console.log("55")
                    //FACTURAR EL SERVICIO
                    //Calcular dias de oferta
                    let numDiasAFactConOf = 0, porcDctoOferta = 0, numDiasAFactSinOfServ = 0
                    if(tieneOferta){
                      let servOf = elemento.oferta.servicios
                      // console.log(servOf)
                      const indexSearch = servOf.findIndex( servicio => servicio.codigoServicio===elemento1.codigoServicio )
                      if(indexSearch!==-1){
                        if(servOf[indexSearch].fechaFinOferta.substr(0, 7)===mesMsg){
                          porcDctoOferta = servOf[indexSearch].porcDctoOferta
                          numDiasAFactConOf = parseInt(servOf[indexSearch].fechaFinOferta.substr(8, 2), 10) - numDiasAFactSinOf
                        }else{
                          if(servOf[indexSearch].fechaFinOferta.substr(0, 7)>mesMsg){
                            porcDctoOferta = servOf[indexSearch].porcDctoOferta
                            numDiasAFactConOf = numDiasMes - numDiasAFactSinOf
                          }
                        }
                      }
                    }
                    numDiasAFactSinOfServ = numDiasMes - numDiasAFactConOf
                    // console.log(numDiasAFactSinOf)
                    // console.log(numDiasAFactSinOfServ)
                    // console.log(numDiasAFactConOf)
                    // console.log(porcDctoOferta)

                    // const valorServ = Math.round((elemento1.valorServicios / numDiasMes) * numDiasAFactSinOfServ)
                    // const valorAntesI = Math.round((elemento1.valorAntesImptos / numDiasMes) * numDiasAFactSinOfServ)
                    let valorServ = elemento1.valorServicios
                    let valorAntesI = elemento1.valorAntesImptos
                    //     if(elemento.contrato==="7523"||elemento.contrato==="6138"||elemento.contrato==="6377"||
                    //     elemento.contrato==="15525"){
                    //   console.log(elemento.contrato, valorServ)
                    // }
                        
                    if(valorServ!==0){
                      listServCargoFra.push({codigoServicio: elemento1.codigoServicio, nombreResumido: elemento1.nombreResumido,
                        descripcionServicio: elemento1.descripcionServicio, descrClaseServ: elemento1.subclaseserv.claseserv.descrClaseServ,
                        velEfecDownstream: elemento1.velEfecDownstream, velEfecUpstream: elemento1.velEfecUpstream,
                        codigoTipoTec: elemento1.codigoTipoTec, descrTipoTec: elemento1.descrTipoTec,
                        numeroServicios: elemento1.numeroServicios, valorServicios: valorServ,
                        imptos: elemento1.imptos, agnoFra: mesMsg.substr(0, 4), mesFra: mesMsg.substr(5, 2), fechaCargo: this.state.argsDocum.fechaFact,
                        periodoFrado: periodoFrado, valorAntesImptos: valorAntesI,
                        numDiasAFactSinOf: numDiasAFactSinOfServ, numDiasAFactConOf: numDiasAFactConOf,
                        porcDctoOferta: porcDctoOferta,
                        _id: i
                      });
                      // console.log(listServCargoFra)
                      // console.log("22")
                    }
                  }
                })
                // if(elemento.contrato==="7523"||elemento.contrato==="6138"||elemento.contrato==="6377"||
                //   elemento.contrato==="15525"){
                //     console.log(elemento.contrato, listServCargoFra, valorFacturado, valorSinFra, valorFacturadoCC)
                // }
              }

              // console.log(listServCargoFra)
              // if(elemento.contrato==="99"){
              //   console.log(listServCargoFra)
              // }

              //crea registros en movclientes
              movCli = []
              movCliI = []
              // console.log(valorFacturado)
              let valorFact = valorFacturado - valorFacturadoCC
              let valorAntesI = valorAntesImptos - valorAntesImptosCC
              let tieneValNeg = false
              let numValPos = 0
              let numValNeg = 0
              let valAFact = 0
              let valAFactAntesI = 0
              let totPagoAdelSinFrarPend = totPagoAdelSinFrar
              listServCargoFra.forEach((elemento1, i) => {
                if(elemento1.valorServicios<0){
                  tieneValNeg = true
                  numValNeg += 1
                }else{
                  numValPos += 1
                }

                let valAFactServ = parseInt(elemento1.valorServicios, 10)
                let valAFactAntesIServ = parseInt(elemento1.valorAntesImptos, 10)
                if(totPagoAdelSinFrarPend>0&&porcFact>0){
                  if(totPagoAdelSinFrarPend>=parseInt(elemento1.valorServicios-Math.round(elemento1.valorServicios * porcFact / 100), 10)){
                    valAFactServ = parseInt(Math.round(elemento1.valorServicios * porcFact / 100), 10)
                    valAFact += valAFactServ
                    let totPagoAdelSinFrarDctar = parseInt(elemento1.valorServicios-Math.round(elemento1.valorServicios * porcFact / 100), 10)
                    totPagoAdelSinFrarPend -= totPagoAdelSinFrarDctar
                    valAFactAntesIServ = parseInt(Math.round(elemento1.valorAntesImptos * porcFact / 100), 10)
                    valAFactAntesI += valAFactAntesIServ
                  }else{
                    valAFactServ = elemento1.valorServicios-totPagoAdelSinFrarPend
                    valAFact += valAFactServ
                    totPagoAdelSinFrarPend=0
                    let porcAFact = valAFactServ*100/elemento1.valorServicios
                    valAFactAntesIServ = parseInt(elemento1.valorAntesImptos, 10)*porcAFact/100
                    valAFactAntesI += valAFactAntesIServ
                  }
                }else{
                  valAFact += parseInt(elemento1.valorServicios, 10)
                  valAFactAntesI += parseInt(elemento1.valorAntesImptos, 10)
                }


                // if(elemento.contrato==="7523"||elemento.contrato==="6138"||elemento.contrato==="6377"||
                //   elemento.contrato==="15525"){
                //     console.log(elemento.contrato, elemento1.valorServicios, numDiasMes, elemento1.valorAntesImptos)
                //     console.log(elemento.contrato, elemento1.numDiasAFactSinOf, elemento1.numDiasAFactConOf, elemento1.porcDctoOferta)
                // }
                // console.log(elemento1.valorServicios, numDiasMes, elemento1.numDiasAFactSinOf)
                // console.log(elemento1.valorAntesImptos, numDiasMes, elemento1.numDiasAFactSinOf)
                if(numDiasMes===elemento1.numDiasAFactSinOf){
                  valorFact += elemento1.valorServicios
                  valorAntesI += elemento1.valorAntesImptos
                  // valorFact += valAFactServ
                  // valorAntesI += valAFactAntesI
                }else{
                  let valorFactDia = elemento1.valorServicios / numDiasMes
                  // console.log(valorFactDia)
                  let valorAntesIDia = elemento1.valorAntesImptos / numDiasMes
                  valorFact += (valorFactDia * elemento1.numDiasAFactSinOf) + (valorFactDia * elemento1.numDiasAFactConOf * ((100 - elemento1.porcDctoOferta) / 100))
                  // console.log(valorFact)
                  valorAntesI += (valorAntesIDia * elemento1.numDiasAFactSinOf) + (valorAntesIDia * elemento1.numDiasAFactConOf * ((100 - elemento1.porcDctoOferta) / 100))
                  valorFact = parseInt(valorFact, 10)
                  // console.log(valorFact)
                  valorAntesI = parseInt(valorAntesI, 10)
                }
                // console.log(valorFact, valorAntesI)
              })

              let ctrlNumValPosONumValNegMenorQue2 = true
              if(numValPos>1&&numValNeg>1){
                ctrlNumValPosONumValNegMenorQue2 = false
                // if(elemento.contrato==="93317"){
                //   console.log(elemento.contrato, numValPos, numValNeg, ctrlNumValPosONumValNegMenorQue2)
                // }
              }
              let ctrlNO_TienePosYNegYSaldoIniMenor0YSaldoFinMayor0 = true
              let saldoFin = valAFact+saldoCl
              // if(elemento.contrato==="1201"||elemento.contrato==="187"||elemento.contrato==="6855"){
              //   console.log(elemento.contrato, numValPos, numValNeg, saldoCl, valAFact, saldoFin)
              // }
              if(numValPos>0&&numValNeg>0&&saldoCl<0&&saldoFin>0&&saldoFin+saldoCl>0){
                ctrlNO_TienePosYNegYSaldoIniMenor0YSaldoFinMayor0 = false
              }
              let ctrlTienePosYNeg = false
              if(numValPos>0&&numValNeg>0){
                ctrlTienePosYNeg = true
                // if(elemento.contrato==="1201"){
                //   console.log(elemento.contrato, numValPos, numValNeg, ctrlNumValPosONumValNegMenorQue2)
                // }
              }
              // if(elemento.contrato==="4802"){
              //   console.log(valorFact)
              // }
              //Crear factura y actualizar detalleFact
              //si hay detalle a facturar => crea la factura

              //se revisa si tiene saldo negativo => si tiene se calcula si queda valor por facturar
              let nuevoValorFact = valorFact
              let porcValorFact = 100
              // if(totPagoAdelSinFrar>0&&porcFact>0&&totPagoAdelSinFrar>=valorFact){
              //   console.log(elemento.contrato, totPagoAdelSinFrar, valorFact)
              //   nuevoValorFact = Math.round(nuevoValorFact * porcFact / 100)
              //   porcValorFact = porcFact
              // }
              // if(totPagoAdelSinFrar>0&&porcFact>0&&totPagoAdelSinFrar>=valorFact){
              if(totPagoAdelSinFrar>0&&porcFact>0){
                nuevoValorFact = valAFact
              }
              if(porcFact>0){
                // console.log(elemento.contrato, totPagoAdelSinFrar, valorFact)
                porcValorFact = porcFact
              }
              // console.log(elemento.contrato, nuevoValorFact, porcValorFact, totPagoAdelSinFrarPend)
              // if(saldoCl<0){
              //   if(valorFact + saldoCl>0){
              //     nuevoValorFact = valorFact + saldoCl
              //     porcValorFact = nuevoValorFact * 100 / valorFact
              //     saldoAnterior =0
              //   }else{
              //     nuevoValorFact = 0
              //   }
              // }
              // if(elemento.contrato==="7523"||elemento.contrato==="6138"||elemento.contrato==="6377"||
              //     elemento.contrato==="15525"){
              //   console.log(elemento.contrato, totPagoAdelSinFrar, valorFact)
              // }

              let totPagoAdelSinFrarIni = totPagoAdelSinFrar
              let totPagoAdelSinFrarInicial = totPagoAdelSinFrar
              totPagoAdelSinFrar = totPagoAdelSinFrarPend
              // if(elemento.contrato==="4802"||elemento.contrato==="33654"||elemento.contrato==="37347"||
              //     elemento.contrato==="23214"||elemento.contrato==="26956"){
              //   console.log(elemento.contrato, totPagoAdelSinFrarIni, totPagoAdelSinFrar, valorFact, porcValorFact, porcFact, nuevoValorFact)
              // }

              // if(totPagoAdelSinFrar>0&&nuevoValorFact>0){
              //   // if(elemento.contrato==="23214"||elemento.contrato==="4802"||elemento.contrato==="34901"||
              //   //   elemento.contrato==="29120"||elemento.contrato==="74775"||elemento.contrato==="83580"){
              //   // console.log(elemento.contrato, totPagoAdelSinFrarIni, totPagoAdelSinFrar, valorFact, porcValorFact, porcFact, nuevoValorFact)
              //   // }
              //   // if(totPagoAdelSinFrar>0&&porcFact>0&&totPagoAdelSinFrar>=valorFact){
              //   //   valorAntesI = valorAntesI * porcFact / 100
              //   // }
              //   if(totPagoAdelSinFrar>nuevoValorFact||(porcFact>0&&totPagoAdelSinFrar>=nuevoValorFact)){
              //     // if(elemento.contrato==="23214"||elemento.contrato==="4802"||elemento.contrato==="34901"||
              //     // elemento.contrato==="29120"||elemento.contrato==="74775"||elemento.contrato==="83580"){
              //     // console.log(elemento.contrato, totPagoAdelSinFrarIni, totPagoAdelSinFrar, valorFact, porcValorFact, porcFact, nuevoValorFact)
              //     // }
              //     totPagoAdelSinFrarIni = nuevoValorFact
              //     // totPagoAdelSinFrar = totPagoAdelSinFrar - nuevoValorFact
              //     console.log(elemento.contrato, totPagoAdelSinFrarIni, totPagoAdelSinFrar, nuevoValorFact, porcFact, valorAntesI)
              //     if(porcFact===0){
              //       nuevoValorFact = 0
              //     }
              //   }else{
              //     // if(elemento.contrato==="23214"||elemento.contrato==="4802"||elemento.contrato==="34901"||
              //     // elemento.contrato==="29120"||elemento.contrato==="74775"||elemento.contrato==="83580"){
              //     // console.log(elemento.contrato, totPagoAdelSinFrarIni, totPagoAdelSinFrar, valorFact, porcValorFact, porcFact, nuevoValorFact)
              //     // }

              //     // nuevoValorFact = nuevoValorFact - totPagoAdelSinFrar
              //     // valorAntesI = valorAntesI - totPagoAdelSinFrar

              //     totPagoAdelSinFrar = 0
              //     console.log(elemento.contrato, totPagoAdelSinFrarIni, totPagoAdelSinFrar, nuevoValorFact, porcFact, valorAntesI)
              //   }
              // }

              // if(saldoCl<0&&nuevoValorFact>0){
              if(saldoCl<0&&nuevoValorFact>0&&totPagoAdelSinFrarIni<=0){
               // if(elemento.contrato==="4802"||elemento.contrato==="33654"||elemento.contrato==="37347"||
                //   elemento.contrato==="23214"||elemento.contrato==="26956"){
                // console.log(elemento.contrato, totPagoAdelSinFrarIni, totPagoAdelSinFrar, valorFact, porcValorFact, porcFact, nuevoValorFact)
                // }
                if((valorFact + saldoCl)>0&&valorSinFra>0){
                  // if(elemento.contrato==="4802"||elemento.contrato==="33654"||elemento.contrato==="37347"||
                  //   elemento.contrato==="23214"||elemento.contrato==="26956"){
                  // console.log(elemento.contrato, totPagoAdelSinFrarIni, totPagoAdelSinFrar, valorFact, porcValorFact, porcFact, nuevoValorFact)
                  // }
                  nuevoValorFact = valorFact + saldoCl
                  if(nuevoValorFact<valorSinFra){
                    // if(elemento.contrato==="4802"||elemento.contrato==="33654"||elemento.contrato==="37347"||
                    //   elemento.contrato==="23214"||elemento.contrato==="26956"){
                    // console.log(elemento.contrato, totPagoAdelSinFrarIni, totPagoAdelSinFrar, valorFact, porcValorFact, porcFact, nuevoValorFact)
                    // }
                    nuevoValorFact = valorSinFra
                  }
                  porcValorFact = nuevoValorFact * 100 / valorFact
                  saldoAnterior = 0
                }else{
                  // if(elemento.contrato==="4802"||elemento.contrato==="33654"||elemento.contrato==="37347"||
                  //   elemento.contrato==="23214"||elemento.contrato==="26956"){
                  // console.log(elemento.contrato, totPagoAdelSinFrarIni, totPagoAdelSinFrar, valorFact, porcValorFact, porcFact, nuevoValorFact)
                  // }
                  if(valorSinFra>0){
                    // if(elemento.contrato==="4802"||elemento.contrato==="33654"||elemento.contrato==="37347"||
                    //   elemento.contrato==="23214"||elemento.contrato==="26956"){
                    // console.log(elemento.contrato, totPagoAdelSinFrarIni, totPagoAdelSinFrar, valorFact, porcValorFact, porcFact, nuevoValorFact)
                    // }
                      nuevoValorFact = valorSinFra
                  }
                }
              }

              // if(valorAntesI>0&&porcFact>0){
              //   valorAntesI = valorAntesI * porcFact / 100
              // }
              porcValorFact = 100
              // if(elemento.contrato==="4802"||elemento.contrato==="33654"||elemento.contrato==="37347"||
              //   elemento.contrato==="23214"||elemento.contrato==="26956"){
              //   console.log(elemento.contrato, totPagoAdelSinFrarIni, totPagoAdelSinFrar, valorFact, porcValorFact, porcFact, nuevoValorFact)
              // }

              // let linea1DNN = ""
              linea1DNN = ""
              if(elemento.direccion.descrTipoVia1){
                linea1DNN = elemento.direccion.descrTipoVia1?elemento.direccion.descrTipoVia1:""
                linea1DNN += elemento.direccion.numeroTipoVia1?" " + elemento.direccion.numeroTipoVia1:""
                linea1DNN += elemento.direccion.descrTipoVia2?" " + elemento.direccion.descrTipoVia2:""
                linea1DNN += elemento.direccion.numeroTipoVia2?" " + elemento.direccion.numeroTipoVia2:""
                linea1DNN += elemento.direccion.numeroTipoVia2F?" " + elemento.direccion.numeroTipoVia2F:""
                linea1DNN += elemento.direccion.descrTipoUnd1?" " + elemento.direccion.descrTipoUnd1:""
                linea1DNN += elemento.direccion.numeroTipoUnd1?" " + elemento.direccion.numeroTipoUnd1:""
                linea1DNN += elemento.direccion.descrTipoUnd2?" " + elemento.direccion.descrTipoUnd2:""
                linea1DNN += elemento.direccion.numeroTipoUnd2?" " + elemento.direccion.numeroTipoUnd2:""
              }

              // if(this.state.argsDocum.noFactRET==="true"){
              //   if(elemento.estadoCliente==="RETIRADO"&&elemento.saldoPendiente<=0){
              //     console.log(elemento.contrato, nuevoValorFact)

              //     nuevoValorFact = 0
              //     creaFra = []
              //   }
              // }

              if(nuevoValorFact>0){
                creaFra = []
                // console.log(elemento.contrato, saldoAnterior, nuevoValorFact)
                argsUpd = {
                  "codProcFact": codProcFact,
                  "idRangoFact": this.state.argsDocum._id,
                  "tipoGen": "proceso",
                  "numeroFra": proxFact,
                  "fechaFact": this.state.argsDocum.fechaFact,
                  "contrato": elemento.contrato,
                  "pagueHasta": this.state.argsDocum.pagueHasta,
                  "direccion": linea1DNN,
                  "descrDpto": elemento.dirmayor.descrDpto,
                  "codigoDptoDANE": elemento.dirmayor.codigoDptoDANE,
                  "nombreCiudad": elemento.dirmayor.ciudades.nombreCiudad,
                  "codigoMunicipioDANE": elemento.dirmayor.ciudades.codigoMunicipioDANE,
                  "codigoPostalDANE": elemento.dirmayor.ciudades.codigoPostalDANE,
                  "codigoCiudadInterno": elemento.dirmayor.ciudades.codigoCiudadInterno,
                  "codBarrasRdo": elemento.dirmayor.ciudades.codBarrasRdo,
                  "nombreZona": elemento.dirmayor.ciudades.zonas.nombreZona,
                  "nombreBarrio": elemento.dirmayor.ciudades.zonas.barrios.nombreBarrio,
                  "nombreCliente": elemento.nombreCliente,
                  "apellidoCliente": elemento.apellidoCliente,
                  "numeroDoc": elemento.numeroDoc,
                  "eMail": elemento.eMail,
                  "fechaMov": fechaHoy,
                  "valorAntesImptos": parseInt(valorAntesI * porcValorFact / 100, 10),
                  "valorFacturado": nuevoValorFact,
                  "valorFactura": (saldoAnterior + totPagoAdelSinFrarInicial) + nuevoValorFact,
                  "agno": mesMsg.substr(0, 4),
                  "mes": mesMsg.substr(5, 2),
                  "numeroDocum": elemento.dirmayor.ciudades.zonas.barrios.numeroDocumR,
                  "descrRecurso": elemento.dirmayor.ciudades.zonas.barrios.descrRecursoR,
                  "usuarioCreate": sessionStorage.getItem('userLogin'),
                  "fechaCreate": fechaHoraHoy,
                };
                creaFra.push(argsUpd)
                // console.log(elemento.contrato, saldoAnterior, totPagoAdelSinFrarInicial, nuevoValorFact, valorAntesI, porcValorFact)
                // if(elemento.contrato==="TTT53"){
                  // console.log(elemento.contrato, saldoAnterior, nuevoValorFact, argsUpd)
                // }
                          }
                // console.log(valorFact)
                // if(elemento.contrato==="23214"||elemento.contrato==="4802"||elemento.contrato==="34901"||
                //     elemento.contrato==="29120"||elemento.contrato==="74775"||elemento.contrato==="83580"){
                //   console.log(creaFra, saldoAnterior, totPagoAdelSinFrarInicial, nuevoValorFact, valorAntesI, porcValorFact)
                // }
                // console.log("crea factura")
                // console.log(elemento.contrato, listServCargoFra)

                let saldoClFra = 0
                let saldoNegPend = 0
                let updValPagar = true
                // let tieneValNeg = false
                listServCargoFra.forEach((elemento1, i) => {
                  // console.log(elemento.contrato, elemento1)
                  let servicioFra = this.props.allServicios.allServicios.filter(servicio => servicio.codigoServicio === elemento1.codigoServicio)
                  let conceptoEnFra = ""
                  let consecEnFra = -1
                  if(servicioFra.length>0){
                    conceptoEnFra = servicioFra[0].conceptoEnFra
                    consecEnFra = servicioFra[0].consecEnFra
                  }else{
                    conceptoEnFra = elemento1.concepto
                    consecEnFra = 9
                  }

                  // console.log(elemento1.valorServicios, numDiasMes, elemento1.numDiasAFactSinOf)
                  // console.log(elemento1.valorAntesImptos, numDiasMes, elemento1.numDiasAFactSinOf)
                  let valorServicios = 0, valorAntesImptos = 0
                  if(numDiasMes===elemento1.numDiasAFactSinOf){
                    // console.log(conceptoEnFra, elemento1.valorServicios, elemento1.valorAntesImptos)
                    valorServicios = elemento1.valorServicios
                    valorAntesImptos = elemento1.valorAntesImptos
                  }else{
                    // console.log(conceptoEnFra, numDiasMes, elemento1.numDiasAFactSinOf, elemento1.porcDctoOferta, elemento1.valorServicios, elemento1.valorAntesImptos)
                    let valorServiciosDia = elemento1.valorServicios / numDiasMes
                    let valorAntesImptosDia = elemento1.valorAntesImptos / numDiasMes
                    valorServicios = (valorServiciosDia * elemento1.numDiasAFactSinOf) + (valorServiciosDia * elemento1.numDiasAFactConOf * ((100 - elemento1.porcDctoOferta) / 100))
                    valorAntesImptos = (valorAntesImptosDia * elemento1.numDiasAFactSinOf) + (valorAntesImptosDia * elemento1.numDiasAFactConOf * ((100 - elemento1.porcDctoOferta) / 100))
                  }
                  // console.log(valorServicios, valorAntesImptos, saldoCl, saldoClFra)
                  // console.log(valorServicios)
                  // console.log(elemento.contrato, valorServicios, saldoCl, saldoClFra, tieneValNeg)
                  if(valorServicios>0&&saldoCl<0&&saldoClFra>0&&tieneValNeg){
                    // console.log("11")
                    updValPagar = false
                  }
                  // if(valorServicios<0){
                  //   tieneValNeg = true
                  // }
                  saldoCl += parseInt(valorServicios, 10)
                  let valorPag = 0
                  let valorPend = 0
                  // console.log(elemento.contrato, valorServicios, saldoCl, saldoClFra, tieneValNeg, saldoNegPend)
                  // if(elemento.contrato==="1201"){
                  //   console.log("11", elemento.contrato, saldoCl, valorServicios, saldoClFra, tieneValNeg, ctrlNumValPosONumValNegMenorQue2, ctrlNO_TienePosYNegYSaldoIniMenor0YSaldoFinMayor0, updValPagar)
                  // }
                  if((saldoCl<valorServicios&&saldoCl>0&&saldoClFra>=0&updValPagar&updValPagar&&ctrlNumValPosONumValNegMenorQue2&&(!tieneValNeg||!ctrlNO_TienePosYNegYSaldoIniMenor0YSaldoFinMayor0))||
                      (saldoCl<valorServicios&&saldoCl>0&&saldoClFra>=0&&updValPagar&&tieneValNeg)){
                    // if((saldoCl<valorServicios&&saldoCl>0&&saldoClFra>=0&&updValPagar&&!tieneValNeg)||
                    //     (saldoCl<valorServicios&&saldoCl>0&&saldoClFra>0&&updValPagar&&tieneValNeg)||
                    //     (saldoCl<valorServicios&&saldoCl>0&&saldoClFra>=0&&updValPagar&&ctrlTienePosYNeg)){
                    // if(saldoCl<valorServicios&&saldoCl>0&&saldoClFra>=0&&updValPagar){
                    // if(valorServicios===-7500&&elemento.contrato==="1201"){
                    // if(elemento.contrato==="1201"){
                    //   console.log("22", elemento.contrato, saldoCl, valorServicios, saldoClFra, tieneValNeg, ctrlNumValPosONumValNegMenorQue2, ctrlNO_TienePosYNegYSaldoIniMenor0YSaldoFinMayor0)
                    // }
                    valorPag = parseInt(valorServicios, 10) - saldoCl
                  }

                  if(valorServicios-saldoCl>0&&saldoCl>0&&saldoClIni<0&&saldoClFra<0&&updValPagar&&ctrlNO_TienePosYNegYSaldoIniMenor0YSaldoFinMayor0){
                  // if(valorServicios-saldoCl>0&&saldoCl>0&&saldoClIni<0&&saldoClFra<0&&updValPagar){
                  // if(valorServicios===64900&&elemento.contrato==="1201"){
                    // if(elemento.contrato==="1201"){
                    //   console.log("33", elemento.contrato, valorServicios, saldoCl, saldoClFra, saldoClIni, updValPagar, ctrlNumValPosONumValNegMenorQue2, ctrlNO_TienePosYNegYSaldoIniMenor0YSaldoFinMayor0)
                    // }
                    valorPag = parseInt(valorServicios-saldoCl, 10) + saldoClFra
                  }
                  // valorServicios, saldoCl,  saldoClFra, saldoClIni, updValPagar, ctrlNumValPosONumValNegMenorQue2, ctrlNO_TienePosYNegYSaldoIniMenor0YSaldoFinMayor0
                  // 69900           60020     -2380       -7500       true         true                              false
                  // if((saldoCl<=0&&saldoClFra<0)||(saldoCl<=0&&valorServicios>0)){
                  // OJOOO en 20210920 se agregó      ||((saldoCl+valorServicios)<=0)
                  // if((saldoCl<=0&&saldoClFra<0&&valorServicios>0)||(saldoCl<=0&&valorServicios>0)||
                  //   ((saldoCl+valorServicios)<=0&&valorServicios<0)){
                  // console.log(elemento.contrato, saldoCl, saldoClFra, valorServicios)
                  // if(elemento.contrato==="1201"){
                  //   console.log("44", elemento.contrato, saldoCl, valorServicios, saldoClFra, tieneValNeg, valorPag)
                  // }
                  // if((saldoCl<0&&saldoClFra<0&&saldoCl<=saldoClFra&&valorServicios>0)||(saldoCl<=0&&saldoClFra>=0&&valorServicios>0)){
                  if((saldoCl<=0&&saldoClFra<=0&&saldoCl<=saldoClFra&&valorServicios>0&&ctrlNumValPosONumValNegMenorQue2)||
                      (saldoCl<=0&&saldoClFra>=0&&valorServicios>0&&!tieneValNeg)||
                      (saldoCl<=0&&saldoClFra>0&&valorServicios>0&&tieneValNeg)){
                    // if(valorServicios===-7500&&elemento.contrato==="1201"){
                    // console.log(elemento.contrato, saldoCl, valorServicios, saldoClFra)
                    // if(elemento.contrato==="1201"){
                    //   console.log("55", elemento.contrato, saldoCl, valorServicios, saldoClFra, tieneValNeg, valorPag)
                    // }
                    // if(elemento.contrato==="1650"){
                    //   valorPag = 0
                    // }else{
                    //   valorPag = parseInt(valorServicios, 10)
                    // }
                    // elemento.contrato saldoCl valorServicios  saldoClFra  tieneValNeg   valorPag
                    // 93317             -16713  23287           0           true          0
                    // if(((saldoCl+valorServicios)<=0&&valorServicios<0&&saldoCl>0)){
                    // valorPag = parseInt(valorServicios, 10) - saldoCl
                    // }else{
                    valorPag = parseInt(valorServicios, 10)
                    // }
                  }
                  if(saldoNegPend>0&&valorPag===0){
                    valorPag = saldoNegPend
                    // if(elemento.contrato==="1201"){
                    //   console.log("66", elemento.contrato, valorPag)
                    // }
                  }

                  saldoClFra += parseInt(valorServicios, 10)
                  // console.log(elemento.contrato, saldoNegPend, valorServicios, saldoCl, saldoClFra)
                  // if(valorServicios<0&&saldoCl<0 &&saldoCl<valorServicios){
                  // if(saldoNegPend>0&&valorServicios<0&&saldoCl<0 &&saldoCl<valorServicios){
                  if(((valorServicios>0)||(saldoNegPend>=0&&valorServicios<0))&&saldoCl<0&&saldoCl<valorServicios){
                    // if(((valorServicios>0&&saldoCl<=saldoClFra)||(saldoNegPend>0&&valorServicios<0))&&saldoCl<0&&saldoCl<valorServicios){
                    // if(elemento.contrato==="1201"){
                    //   console.log("77", elemento.contrato, saldoNegPend, valorServicios, saldoCl, saldoClFra)
                    //   }  
                    if(valorServicios>0&&saldoCl<=saldoClFra&&saldoClFra<0){
                      // if(elemento.contrato==="1201"){
                      // console.log("88", elemento.contrato, saldoNegPend, valorServicios, saldoCl, saldoClFra)
                      // }
                      saldoNegPend = 0
                    }else{
                      // if(valorServicios===-23742){
                      // if(elemento.contrato==="1201"){
                      //   console.log("99", elemento.contrato, saldoNegPend, valorServicios, saldoCl, saldoClFra)
                      // }
                      saldoNegPend = valorServicios - saldoCl
                    }
                    // console.log(elemento.contrato, saldoNegPend, valorServicios, saldoCl)
                    // console.log(elemento.contrato, saldoNegPend, valorServicios, saldoCl)
                  }else{
                    // if(elemento.contrato==="1201"){
                    //   console.log("1", elemento.contrato, saldoNegPend, valorServicios, saldoCl)
                    // }
                    saldoNegPend = 0
                  }
                  // if(valorServicios<0&&saldoCl<0 &&saldoCl<valorServicios){
                  //   saldoNegPend = valorServicios - saldoCl
                  //   // console.log(elemento.contrato, saldoNegPend)
                  // }else{
                  //   saldoNegPend = 0
                  // }


                  valorServicios = parseInt(valorServicios, 10)
                  valorAntesImptos = parseInt(valorAntesImptos, 10)
                  // console.log(elemento.contrato, valorServicios, valorAntesImptos, saldoCl, valorPag, nuevoValorFact)
                  let valorServiciosPA = valorServicios
                  let valorAntesImptosPA = valorAntesImptos
                  let totPagoAdelSinFrarPendServ = totPagoAdelSinFrarIni
                  if(totPagoAdelSinFrarPendServ>0&&porcFact>0){
                    if(totPagoAdelSinFrarPendServ>=parseInt(valorServiciosPA-Math.round(valorServiciosPA * porcFact / 100), 10)){
                      valorServiciosPA = parseInt(Math.round(valorServiciosPA * porcFact / 100), 10)
                      let totPagoAdelSinFrarDctar = parseInt(valorServiciosPA-Math.round(valorServiciosPA * porcFact / 100), 10)
                      totPagoAdelSinFrarPendServ -= totPagoAdelSinFrarDctar
                      valorAntesImptosPA = parseInt(Math.round(valorAntesImptosPA * porcFact / 100), 10)
                    }else{
                      valorServiciosPA = valorServiciosPA-totPagoAdelSinFrarPendServ
                      totPagoAdelSinFrarPendServ=0
                      let porcAFact = valorServiciosPA*100/valorServiciosPA
                      valorAntesImptosPA = parseInt(valorAntesImptosPA, 10)*porcAFact/100
                    }
                  }



                  // valorServicios = parseInt(valorServicios, 10)
                  // valorAntesImptos = parseInt(valorAntesImptos, 10)
                  // console.log(elemento.contrato, valorServicios, valorAntesImptos, saldoCl, valorPag, nuevoValorFact)
                  // let valorServiciosPA = valorServicios
                  // let valorAntesImptosPA = valorAntesImptos
                  // // console.log(elemento.contrato, valorServiciosPA, elemento1.descripcionServicio, totPagoAdelSinFrarIni, elemento1.imptos)
                  // if(totPagoAdelSinFrarIni>0&&valorServiciosPA>0&&!elemento1.origenCC){
                  //   if(totPagoAdelSinFrarIni>valorServiciosPA){
                  //     // console.log(elemento.contrato)
                  //     totPagoAdelSinFrarIni = totPagoAdelSinFrarIni - valorServiciosPA
                  //     valorServiciosPA = 0
                  //     valorAntesImptosPA = 0
                  //   }else{
                  //     // console.log(elemento.contrato, valorServiciosPA, totPagoAdelSinFrarIni)
                  //     if(valorServiciosPA!==valorAntesImptosPA){
                  //       valorAntesImptosPA = (valorAntesImptosPA * (valorServiciosPA - totPagoAdelSinFrarIni)) / valorServiciosPA
                  //       valorAntesImptosPA = Math.round(valorAntesImptosPA)
                  //     }else{
                  //       valorAntesImptosPA = valorAntesImptosPA - totPagoAdelSinFrarIni
                  //     }
                  //     valorServiciosPA = valorServiciosPA - totPagoAdelSinFrarIni

                  //     totPagoAdelSinFrarIni = 0
                  //   }
                  // }
                  // console.log(nuevoValorFact)

                  if(nuevoValorFact<=0){
                    // console.log(nuevoValorFact)
                    if(saldoCl>nuevoValorFact){
                      // console.log(elemento.contrato, saldoCl, nuevoValorFact)
                      // OJOOO cambiado en 20210916
                      // valorPag = saldoCl
                      if(saldoCl>0){
                        // if(elemento.contrato==="1201"){
                        //   console.log("2", elemento.contrato, saldoCl)
                        // }
                        valorPag = saldoCl
                      }else{
                        // if(elemento.contrato==="1201"){
                        //   console.log("3", elemento.contrato)
                        // }
                        valorPag = 0
                      }
                    }
                    if(saldoCl>0){
                      // if(elemento.contrato==="1201"){
                      //   console.log("4", elemento.contrato, saldoCl)
                      // }
                      valorPag = 0
                    }
                  }
                  // console.log(valorPag, valorServiciosPA, valorServicios)

                  if(valorServiciosPA>0){
                    // console.log(elemento.contrato, valorServiciosPA)
                    // OJOOO cambiado en 20210421
                    // valorPend = valorServicios
                    if(valorServiciosPA >= valorPag){
                      // console.log(elemento.contrato, valorServiciosPA, valorPag)
                      valorPend = valorServiciosPA - valorPag
                    }else{
                      // console.log(elemento.contrato, valorPag)
                      valorPend = 0
                    }
                  }else{
                    // console.log(valorPag)
                    valorPend = 0
                  }
                  // console.log(valorPend, valorPag)
                  movCliI = []
                  elemento1.imptos.forEach((elemento2, ii) => {
                    if(elemento2.codigoImpto!==null){
                      // console.log(elemento2.valorImpto, numDiasMes)
                      let valorImptoDia = elemento2.valorImpto / numDiasMes
                      let valorImpto = (valorImptoDia * elemento1.numDiasAFactSinOf) + (valorImptoDia * elemento1.numDiasAFactConOf * ((100 - elemento1.porcDctoOferta) / 100))
                      valorImpto = Math.round(valorImpto)

                      //crea imptos en movclientes
                      argsUpd = {
                        // "tipoAct": ii===0?"CrearImptoMC1":"CrearImptoMC2",
                        // "origen": "MES-" + mesMsg + ' Contrato-' + elemento.contrato,
                        // "codigoServicio": elemento1.codigoServicio,
                        "codigoImpto": elemento2.codigoImpto,
                        "descrImpto": elemento2.descrImpto,
                        "porcImpto": elemento2.porcImpto,
                        "valorImpto": valorImpto,
                      }
                      movCliI.push(argsUpd)
                      // if(elemento.contrato==="23214"||elemento.contrato==="4802"||elemento.contrato==="34901"||
                      //     elemento.contrato==="29120"||elemento.contrato==="74775"||elemento.contrato==="83580"){
                      //   console.log(elemento.contrato, valorImpto, porcValorFact, argsUpd)
                      // }

                      if(nuevoValorFact>0&&!elemento1.origenCC&&valorServiciosPA>0){
                        //crea det imptos fras
                        argsUpd = {
                          // "tipoAct": "CrearDetFra2",
                          // "numeroFra": proxFact,
                          "codigoServicio": elemento1.codigoServicio,
                          "nombreResumido": elemento1.nombreResumido,
                          "descripcionServicio": elemento1.descripcionServicio,
                          "descrClaseServ": elemento1.descrClaseServ,
                          "velEfecDownstream": elemento1.velEfecDownstream,
                          "velEfecUpstream": elemento1.velEfecUpstream,
                          "codigoTipoTec": elemento1.codigoTipoTec,
                          "descrTipoTec": elemento1.descrTipoTec,            
                          "concepto": elemento2.descrImpto,
                          "periodo": elemento1.periodoFrado,
                          "tipo": "IF",
                          "consecEnFra": consecEnFra,
                          "porcImpto": elemento2.porcImpto,
                          "valor": Math.round(valorImpto * porcValorFact / 100),
                        }
                        movFras.push(argsUpd)
                        // if(elemento.contrato==="23214"||elemento.contrato==="4802"||elemento.contrato==="34901"||
                        //     elemento.contrato==="29120"||elemento.contrato==="74775"||elemento.contrato==="83580"){
                        //   console.log(elemento.contrato, nuevoValorFact, valorServiciosPA, valorImpto, porcValorFact, argsUpd)
                        // }
                      }
                    }
                  })

                  // if(valorServicios<0){
                  //   valorPag=0
                  // }
                  // if(valorServicios===21963){
                  //   valorPag=0
                  //   valorPend=21963
                  // }

                  //crea movclientes
                  argsUpd = {
                    "contrato": elemento.contrato,
                    "fechaMov": fechaHoy,
                    "tipo": "C",
                    "subTipo": "CF",
                    "procesado": "S",
                    "pagueHasta": this.state.argsDocum.pagueHasta,
                    "codigoServicio": elemento1.codigoServicio,
                    "nombreResumido": elemento1.nombreResumido,
                    "descripcionServicio": elemento1.descripcionServicio,
                    "descrClaseServ": elemento1.descrClaseServ,
                    "concepto": conceptoEnFra,
                    "periodo": elemento1.periodoFrado,
                    "origen": "MES " + mesMsg,
                    "saldoCliente": saldoCl,
                    "valorTotal": valorServicios,
                    "valorAntesImptos": valorAntesImptos,
                    "agno": elemento1.agnoFra,
                    "mes": elemento1.mesFra,
                    "numeroFra": nuevoValorFact>0?proxFact:"",
                    "documento": nuevoValorFact>0?proxFact:"",
                    "valorPagado": valorPag,
                    "valorPendiente": valorPend,
                    "usuarioCreate": sessionStorage.getItem('userLogin'),
                    "imptos": movCliI
                  };
                  // console.log(elemento.contrato, valorPag, valorPend, argsUpd)
                  movCli.push(argsUpd)
                  // if(elemento.contrato==="TTT53"){
                    // console.log(elemento.contrato, argsUpd)
                  // }
                  // console.log(elemento.contrato, valorAntesImptosPA, porcValorFact, nuevoValorFact, elemento1.origenCC, totPagoAdelSinFrarIni, valorServiciosPA)
                  if(nuevoValorFact>0&&!elemento1.origenCC&&valorServiciosPA>0){
                    argsUpd = {
                      "codigoServicio": elemento1.codigoServicio,
                      "nombreResumido": elemento1.nombreResumido,
                      "descripcionServicio": elemento1.descripcionServicio,
                      "descrClaseServ": elemento1.descrClaseServ,
                      "velEfecDownstream": elemento1.velEfecDownstream,
                      "velEfecUpstream": elemento1.velEfecUpstream,
                      "codigoTipoTec": elemento1.codigoTipoTec,
                      "descrTipoTec": elemento1.descrTipoTec,  
                      "concepto": conceptoEnFra,
                      "periodo": elemento1.periodoFrado,
                      "tipo": "SF",
                      "consecEnFra": consecEnFra,
                      "valor": parseInt(valorAntesImptosPA * porcValorFact / 100, 10),
                    }
                    movFras.push(argsUpd)
                    // console.log(elemento.contrato, "movFras=>", argsUpd)
                  }
                })
                // }

                // console.log(creaFra)
                // console.log(movFras)
                // console.log(movCli)
                //         console.log(movCliI)
                //         console.log(actmovCli)
                // console.log(creaFra.length)

                //FIN FACTURAR EL MES PARA CLIENTES ACTIVOS

                //GRABAR PROCESO DE FACTURACION PARA EL CLIENTE
                ///////////////////////////////////////
                // if(creaFra.length>0){
                //Para agregar los servicios de CF y despues los impuestos de cada CF en la OS
                // const creaFra_0 = [], creaFra_1 = [], movFras_0 = [], movFras_1 = []
                // // creaFra.forEach((elemento, i) => i===0?creaFra_0.push(elemento):creaFra_1.push(elemento))
                // movFras.forEach((elemento, i) => i===0?movFras_0.push(elemento):movFras_1.push(elemento))

                // const movCli_0 = [], movCli_1 = [], movCliI_0 = [], movCliI_1 = []
                // movCli.forEach((elemento, i) => i===0?movCli_0.push(elemento):movCli_1.push(elemento))
                // movCliI.forEach((elemento, i) => i===0?movCliI_0.push(elemento):movCliI_1.push(elemento))

                //actualizar paguehasta en clientes
                let fechaPH = null
                if(elemento.pagueHasta){
                  // console.log(elemento.pagueHasta)
                  // console.log(this.state.argsDocum.pagueHasta)
                  fechaPH = elemento.pagueHasta.substr(0, 10)

                  let fechaInicio = new Date(elemento.pagueHasta.substr(0, 10)).getTime();
                  let fechaFin = new Date(this.state.argsDocum.pagueHasta.substr(0, 10)).getTime();
                  if(fechaInicio > fechaFin){
                    fechaPH = this.state.argsDocum.pagueHasta
                  }
                }else{
                  fechaPH = this.state.argsDocum.pagueHasta
                }
                // if(elemento.contrato==="W6205"||elemento.contrato==="42986"elemento.contrato==="42986"elemento.contrato==="42986"elemento.contrato==="42986"){
                //   console.log(elemento.contrato, fechaPH, saldoCl)
                // }
                let actCliPH = []
                argsUpd = {
                  "tipoAct": "EditarCliPagueHasta",
                  "contrato": elemento.contrato,
                  "pagueHasta": fechaPH,
                }
                actCliPH.push(argsUpd)

                //actualizar saldoCliente
                let actCli = []
                argsUpd = {
                  "tipoAct": "EditarCliOdeS",
                  "_id": elemento._id,
                  "estadoCliente": elemento.estadoCliente,
                  "cargoMensual": elemento.cargoMensual,
                  "saldoPendiente": saldoCl,
                }
                actCli.push(argsUpd)

                let actPASFCli = []
                argsUpd = {
                  "tipoAct": "EditarCliPagoAdelSF",
                  "contrato": elemento.contrato,
                  "totPagoAdelSinFrar": totPagoAdelSinFrarPend,
                }
                actPASFCli.push(argsUpd)

                // if(this.state.argsDocum.noFactRET==="true"||elemento.noFactOSAb){
                //   if((elemento.estadoCliente==="RETIRADO"&&saldoCl<=0&&creaFra.length===1)||(elemento.estadoCliente==="ACTIVO"&&elemento.noFactOSAb===true)){
                  if(this.state.argsDocum.noFactRET==="true"){
                    if((elemento.estadoCliente==="RETIRADO"&&saldoCl<=0&&creaFra.length===1)){  
                    // console.log(saldoCl)
                    creaFra = []
                    actPASFCli = []
                    actCli = []
                    actCliPH = []
                    movCli = []
                    actMNF = []
                  }
                }
                // if(elemento.contrato==="44676"||elemento.contrato==="223017"||elemento.contrato==="47118"||elemento.contrato==="39838"){
                //   console.log(elemento.contrato)
                // }
                let creaFra1 = {}
                if(creaFra.length===1){
                  //QUITAR DE DETALLEFACT LOS VALORES NEGATIVOS
                  let totValorNegSF = 0, totValorNegIF = 0
                  // movFras.forEach((elementoDetFra, ii) => {
                  for(let ii=0; ii<movFras.length; ii++){
                    let elementoDetFra = movFras[ii]
                    if(elementoDetFra.valor<0){
                      if(elementoDetFra.tipo==="SF"){
                        totValorNegSF += elementoDetFra.valor
                      }else{
                        totValorNegIF += elementoDetFra.valor
                      }
                    }
                  }
                  // if(elemento.contrato==="44676"||elemento.contrato==="223017"||elemento.contrato==="47118"||elemento.contrato==="39838"){
                  //   console.log(elemento.contrato, totValorNegSF, totValorNegIF)
                  // }
                  // console.log(totValorNegSF, totValorNegIF)
                  let updAntesI = false
                  if(totValorNegSF<0||totValorNegIF<0){
                    let updValor = false
                    // Descuenta valores negativos a los positivos del mismo servicio
                    for(let ii=0; ii<movFras.length; ii++){
                      let elementoDetNeg = movFras[ii]
                      // if(elemento.contrato==="44676"||elemento.contrato==="223017"||elemento.contrato==="47118"||elemento.contrato==="39838"){
                        // console.log(elemento.contrato, elementoDetNeg.descripcionServicio, elementoDetNeg.periodo, elementoDetNeg.tipo, elementoDetNeg.valor)
                      // }
                      if(elementoDetNeg.valor<0){
                        // console.log(elemento.contrato, elementoDetNeg.descripcionServicio, elementoDetNeg.periodo, elementoDetNeg.tipo, elementoDetNeg.valor)
                        for(let iii=0; iii<movFras.length; iii++){
                          let elementoDetPos = movFras[iii]
                          if(elementoDetPos.valor>0&&elementoDetNeg.tipo===elementoDetPos.tipo&&
                              elementoDetNeg.descripcionServicio===elementoDetPos.descripcionServicio){
                            if((elementoDetPos.valor + movFras[ii].valor)>0){
                              // console.log(elemento.contrato, elementoDetNeg.descripcionServicio, elementoDetNeg.periodo, elementoDetNeg.tipo, movFras[ii].valor, elementoDetPos.valor)
                              let nuevoValor = elementoDetPos.valor + movFras[ii].valor
                              // console.log(nuevoValor)
                              // updValor = true
                              movFras[iii].valor = nuevoValor
                              movFras[ii].valor = 0
                            }else{
                              // console.log(elemento.contrato, elementoDetNeg.descripcionServicio, elementoDetNeg.periodo, elementoDetNeg.tipo, movFras[ii].valor, elementoDetPos.valor)
                              let nuevoValor = movFras[ii].valor + elementoDetPos.valor
                              // console.log(nuevoValor)
                              // updValor = true
                              movFras[iii].valor = 0
                              movFras[ii].valor = nuevoValor
                            }
                          }
                        }
                      }
                    }

                    // Si quedan valores negativos, descuenta valores negativos a los positivos de cualquier servicio
                    for(let ii=0; ii<movFras.length; ii++){
                      let elementoDetNeg = movFras[ii]
                      // if(elemento.contrato==="44676"||elemento.contrato==="223017"||elemento.contrato==="47118"||elemento.contrato==="39838"){
                        // console.log(elemento.contrato, elementoDetNeg.descripcionServicio, elementoDetNeg.periodo, elementoDetNeg.tipo, elementoDetNeg.valor)
                      // }
                      if(elementoDetNeg.valor<0){
                        // console.log(elemento.contrato, elementoDetNeg.descripcionServicio, elementoDetNeg.periodo, elementoDetNeg.tipo, elementoDetNeg.valor)
                        for(let iii=0; iii<movFras.length; iii++){
                          let elementoDetPos = movFras[iii]
                          if(elementoDetPos.valor>0&&elementoDetNeg.tipo===elementoDetPos.tipo){
                            if((elementoDetPos.valor + movFras[ii].valor)>0){
                              // console.log(elemento.contrato, elementoDetNeg.descripcionServicio, elementoDetNeg.periodo, elementoDetNeg.tipo, movFras[ii].valor, elementoDetPos.valor)
                              let nuevoValor = elementoDetPos.valor + movFras[ii].valor
                              // console.log(nuevoValor)
                              updValor = true
                              movFras[iii].valor = nuevoValor
                              movFras[ii].valor = 0
                            }else{
                              // console.log(elemento.contrato, elementoDetNeg.descripcionServicio, elementoDetNeg.periodo, elementoDetNeg.tipo, movFras[ii].valor, elementoDetPos.valor)
                              
                              // Revisar si el SF tiene IF
                              let valorIF = 0
                              let updIF = false
                              for(let jj=0; jj<movFras.length; jj++){
                                // console.log(movFras[jj])
                                if(movFras[iii].codigoServicio===movFras[jj].codigoServicio&&
                                    movFras[iii].descripcionServicio===movFras[jj].descripcionServicio&&
                                    movFras[iii].periodo===movFras[jj].periodo&&movFras[jj].tipo==="IF"){
                                  valorIF = movFras[jj].valor
                                  updIF = true
                                  if((elementoDetPos.valor + valorIF + movFras[ii].valor)>0){
                                    let nuevoValor = elementoDetPos.valor + movFras[ii].valor
                                    if(nuevoValor<=0){
                                      valorIF += nuevoValor - 1
                                      nuevoValor = 1
                                    }
                                    // if(elemento.contrato==="23214"||elemento.contrato==="4802"||elemento.contrato==="34901"||
                                    //     elemento.contrato==="29120"||elemento.contrato==="74775"||elemento.contrato==="83580"){
                                    //   console.log(elemento.contrato, nuevoValor, valorIF, elementoDetPos.valor, movFras[ii].valor)
                                    // }
                                    updValor = true
                                    movFras[iii].valor = nuevoValor
                                    movFras[jj].valor = valorIF
                                    movFras[ii].valor = 0
                                  }else{
                                    let nuevoValor = movFras[ii].valor + elementoDetPos.valor + valorIF
                                    updValor = true
                                    movFras[iii].valor = 0
                                    movFras[jj].valor = 0
                                    movFras[ii].valor = nuevoValor
                                    // if(elemento.contrato==="23214"||elemento.contrato==="4802"||elemento.contrato==="34901"||
                                    //     elemento.contrato==="29120"||elemento.contrato==="74775"||elemento.contrato==="83580"){
                                    //   console.log(elemento.contrato, nuevoValor, valorIF, elementoDetPos.valor, movFras[ii].valor)
                                    // }
                                  }    

                                  jj=movFras.length
                                }
                              }
                              if(!updIF){
                                let nuevoValor = movFras[ii].valor + elementoDetPos.valor
                                updValor = true
                                movFras[iii].valor = 0
                                movFras[ii].valor = nuevoValor
                              }
                            }
                          }
                        }
                      }
                    }

                    // Si quedan valores negativos, descuenta valores negativos a cualquier positivo
                    for(let ii=0; ii<movFras.length; ii++){
                      let elementoDetNeg = movFras[ii]
                      // if(elemento.contrato==="44676"||elemento.contrato==="223017"||elemento.contrato==="47118"||elemento.contrato==="39838"){
                        // console.log(elemento.contrato, elementoDetNeg.descripcionServicio, elementoDetNeg.periodo, elementoDetNeg.tipo, elementoDetNeg.valor)
                      // }
                      if(elementoDetNeg.valor<0){
                        // console.log(elemento.contrato, elementoDetNeg.descripcionServicio, elementoDetNeg.periodo, elementoDetNeg.tipo, elementoDetNeg.valor)
                        for(let iii=0; iii<movFras.length; iii++){
                          let elementoDetPos = movFras[iii]
                          if(elementoDetPos.valor>0){
                            if((elementoDetPos.valor + movFras[ii].valor)>0){
                              // console.log(elemento.contrato, elementoDetNeg.descripcionServicio, elementoDetNeg.periodo, elementoDetNeg.tipo, movFras[ii].valor, elementoDetPos.valor)
                              let nuevoValor = elementoDetPos.valor + movFras[ii].valor

                              if(elementoDetNeg.tipo==="IF"){
                                creaFra[0].valorAntesImptos = creaFra[0].valorAntesImptos + movFras[ii].valor
                              }

                              // console.log(nuevoValor)
                              updValor = true
                              movFras[iii].valor = nuevoValor
                              movFras[ii].valor = 0
                            }else{
                              // console.log(elemento.contrato, elementoDetNeg.descripcionServicio, elementoDetNeg.periodo, elementoDetNeg.tipo, movFras[ii].valor, elementoDetPos.valor)
                              let nuevoValor = movFras[ii].valor + elementoDetPos.valor

                              if(elementoDetNeg.tipo==="IF"){
                                creaFra[0].valorAntesImptos = movFras[ii].valor + creaFra[0].valorAntesImptos
                              }

                              // console.log(nuevoValor)
                              updValor = true
                              movFras[iii].valor = 0
                              movFras[ii].valor = nuevoValor
                            }
                          }
                        }
                      }
                    }

                    // Quita todos los valores negativos, deja solo positivos
                    let movFras1 = movFras.filter(detFra => detFra.valor > 0)
                    movFras = movFras1

                    // Revisar que los IF correspondan a los SF
                    // if(updValor = true){
                    if(updValor){
                      for(let ii=0; ii<movFras.length; ii++){
                        // console.log(movFras[ii])
                        if(movFras[ii].tipo==="SF"){
                          let valorSF = movFras[ii].valor
                          for(let iii=0; iii<movFras.length; iii++){
                            if(movFras[iii].codigoServicio===movFras[ii].codigoServicio&&
                              movFras[iii].descripcionServicio===movFras[ii].descripcionServicio&&
                              movFras[iii].periodo===movFras[ii].periodo&&movFras[iii].tipo==="IF"){
                                let valorTot = valorSF + movFras[iii].valor
                                valorSF = Math.round(valorTot / (1 + (Math.round(movFras[iii].porcImpto)/100)))
                                // console.log(movFras[iii].descripcionServicio, valorTot, valorSF)
                                movFras[ii].valor = valorSF
                                movFras[iii].valor = valorTot - valorSF
                            }
                          }
                        }
                      }
                      updAntesI = true
                      let valorAntesImptos = 0
                      for(let ii=0; ii<movFras.length; ii++){
                        if(movFras[ii].tipo==="SF"){
                          valorAntesImptos += movFras[ii].valor
                        }
                      }
                      // console.log(elemento.contrato, valorAntesImptos)
                      creaFra[0].valorAntesImptos = valorAntesImptos
                    }
                  }

                  if(porcFact>0){
                    if(!updAntesI){
                      let valorAntesImptos = 0
                      for(let ii=0; ii<movFras.length; ii++){
                        if(movFras[ii].tipo==="SF"){
                          valorAntesImptos += movFras[ii].valor
                        }
                      }
                      // console.log(elemento.contrato, valorAntesImptos)
                      creaFra[0].valorAntesImptos = valorAntesImptos
                    }

                    for(let ii=0; ii<movFras.length; ii++){
                      // console.log(movFras[ii])
                      if(movFras[ii].tipo==="SF"){
                        let valorSF = movFras[ii].valor
                        for(let iii=0; iii<movFras.length; iii++){
                          if(movFras[iii].codigoServicio===movFras[ii].codigoServicio&&
                            movFras[iii].descripcionServicio===movFras[ii].descripcionServicio&&
                            movFras[iii].periodo===movFras[ii].periodo&&movFras[iii].tipo==="IF"){
                              let valorIF = Math.round(valorSF * (Math.round(movFras[iii].porcImpto)/100))
                              movFras[iii].valor = valorIF
                          }
                        }
                      }
                    }

                    if(creaFra[0].valorFacturado<creaFra[0].valorAntesImptos){
                      let nuevoValorFacturado = 0
                      for(let ii=0; ii<movFras.length; ii++){
                        nuevoValorFacturado += movFras[ii].valor
                      }
                      // nuevoValorFacturado = Math.round(creaFra[0].valorFacturado / (porcFact / 100))
                      // if(creaFra[0].valorFacturado=creaFra[0].valorFactura){
                      //   creaFra[0].valorFactura = nuevoValorFacturado
                      // }
                      creaFra[0].valorFacturado = nuevoValorFacturado
                    }
                    creaFra[0].valorFactura = saldoCl
                    // if(elemento.contrato==="3500"||elemento.contrato==="27661"){
                    //   console.log(elemento.contrato, saldoCl, creaFra[0])
                    // }
                  }
                  ///////////////////////////////////////////////////////////////////////////////

                  //   let totValorNegSF = 0, totValorNegIF = 0
                  //   movFras.forEach((elementoDetFra, ii) => {
                  //     if(elemento.contrato==="44676"||elemento.contrato==="223017"||elemento.contrato==="47118"||elemento.contrato==="39838"){
                  //       console.log(elementoDetFra.descripcionServicio, elementoDetFra.periodo, elementoDetFra.tipo, elementoDetFra.valor, totValorNegSF, totValorNegIF)
                  //     }
                  //     if(elementoDetFra.valor<0){
                  //       console.log(elemento.contrato, elementoDetFra.valor)
                  //       if(elementoDetFra.tipo==="SF"){
                  //         console.log(elemento.contrato, elementoDetFra.valor)
                  //         totValorNegSF += elementoDetFra.valor
                  //       }else{
                  //         console.log(elemento.contrato, elementoDetFra.valor)
                  //         totValorNegIF += elementoDetFra.valor
                  //       }    
                  //       movFras[ii].valor = 0
                  //     }
                  //   })
                  // if(elemento.contrato==="44676"||elemento.contrato==="223017"||elemento.contrato==="47118"||elemento.contrato==="39838"){
                  // // console.log(creaFra)
                  // // console.log(movFras)
                  // console.log(elemento.contrato, totValorNegSF, totValorNegIF)
                  // }
                  //   if(totValorNegSF<0||totValorNegIF<0){
                  //     // console.log(creaFra[0].contrato)
                  //     let dctaIF = 0
                  //     // movFras.forEach((elementoDetFra, ii) => {
                  //     for(let ii=0; ii<movFras.length; ii++){
                  //       let elementoDetFra = movFras[ii]
                  //       // console.log(elementoDetFra)
                  //       if(elementoDetFra.valor>0&&totValorNegSF<0&&(elementoDetFra.valor-totValorNegSF)>0){
                  //         console.log(elementoDetFra.descripcionServicio, elementoDetFra.periodo, elementoDetFra.tipo, elementoDetFra.valor, totValorNegSF, totValorNegIF)
                  //         console.log(elementoDetFra.valor, totValorNegSF)
                  //         if(elementoDetFra.tipo==="SF"&&totValorNegSF<0){
                  //           movFras[ii].valor = elementoDetFra.valor + totValorNegSF
                  //           totValorNegSF = movFras[ii].valor
                  //           // movFras.forEach((elementoDetNeg, iii) => {
                  //           for(let iii=0; iii<movFras.length; iii++){
                  //             let elementoDetNeg = movFras[iii]
                  //             console.log(elementoDetNeg.descripcionServicio, elementoDetNeg.periodo, elementoDetNeg.tipo, elementoDetNeg.valor)
                  //             if(elementoDetNeg.tipo==="IF"&&elementoDetNeg.valor>0&&
                  //                 elementoDetFra.descripcionServicio===elementoDetNeg.descripcionServicio){
                  //                   console.log(elemento.contrato, elementoDetFra.descripcionServicio, elementoDetFra.valor, totValorNegIF)
                  //               movFras[iii].valor = elementoDetNeg.valor + totValorNegIF
                  //               totValorNegIF = 0
                  //             }
                  //           }
                  //           // })
                  //           if(totValorNegIF<0){
                  //             console.log(elementoDetFra.valor, totValorNegIF)
                  //             movFras[ii].valor = elementoDetFra.valor + totValorNegIF
                  //             dctaIF = totValorNegIF
                  //             totValorNegIF = 0
                  //           }
                  //         }else{
                  //           console.log(elementoDetFra.descripcionServicio, elementoDetFra.periodo, elementoDetFra.tipo, elementoDetFra.valor, totValorNegSF, totValorNegIF)
                  //         }
                  //       }else{
                  //         console.log(elementoDetFra.descripcionServicio, elementoDetFra.periodo, elementoDetFra.tipo, elementoDetFra.valor, totValorNegSF, totValorNegIF)
                  //       }
                  //     }
                      // })
                      // let movFras1 = movFras.filter(detFra => detFra.valor > 0)
                      // movFras = movFras1
                    // console.log(dctaIF)
                    // console.log(movFras)
                      // if(dctaIF<0){
                      //   creaFra[0].valorAntesImptos += dctaIF
                      // }
                    // }
                  // console.log(creaFra[0])
                  //FIN QUITAR DE DETALLEFACT LOS VALORES NEGATIVOS
                  // console.log(elemento.contrato, saldoCl, totPagoAdelSinFrarInicial)
                  creaFra1 = (creaFra[0])
                  // creaFra1.saldoPendiente = saldoCl - totPagoAdelSinFrarInicial
                  creaFra1.saldoPendiente = saldoCl
                  if(movFras.length){
                    creaFra1.detalleFact = movFras
                  }
                  // if(elemento.contrato==="3500"||elemento.contrato==="27661"){
                  //   console.log(elemento.contrato, saldoCl, creaFra1)
                  // }
                  creaFraMany.push(creaFra1)
                }else{
                  if(creaFra.length>1){
                    creaFra1 = (creaFra[0])
                    alert("el contrato " +  elemento.contrato + " tiene " + creaFra.length + " facturas")
                  }
                }

                // console.log(movCli)
                // console.log(actmovCli)
                // console.log(actCli)

                //Si saldo cliente <= 0 => se hace pend x pagar 0
                if(saldoCl<=0){
                  // console.log(saldoCl)
                  movCli.forEach((elementoFra, ii) => {
                    if(movCli[ii].valorTotal>0 && movCli[ii].valorPagado!==movCli[ii].valorTotal){
                      // console.log(elemento.contrato, movCli[ii].valorTotal)
                    // if(movCli[ii].valorPagado!==movCli[ii].valorTotal){
                      movCli[ii].valorPagado = movCli[ii].valorTotal
                    }
                  })      
                }

                // creaFraMany.push(creaFra1)
                movCli.forEach((elementoFra, ii) => {
                  movCliMany.push(elementoFra)
                })
                actmovCli.forEach((elementoFra, ii) => {
                  actmovCliMany.push(elementoFra)
                })
                actCliMC.forEach((elementoFra, ii) => {
                  actCliMCMany.push(elementoFra)
                })
                actCli.forEach((elementoFra, ii) => {
                  actCliMany.push(elementoFra)
                })
                actCliPH.forEach((elementoFra, ii) => {
                  actCliPHMany.push(elementoFra)
                })
                actPASFCli.forEach((elementoFra, ii) => {
                  actPASFCliMany.push(elementoFra)
                })
                actMNF.forEach((elementoFra, ii) => {
                  actMNFMany.push(elementoFra)
                })

                if(creaFra.length>0){
                  //CREA REGISTRO EN HISTCLIENTES
                  let argsAddHC = {
                    "fechaHistCliente": fechaHoy + ' ' + horaHoy,
                    "contrato": elemento.contrato,
                    "movimiento": "Facturacion",
                    "descripcion": "Proceso de Facturacion",
                    "detalle": mesMsg.substr(0, 4) + "-" + mesMsg.substr(5, 2),
                    "relacion": proxFact,
                    "valor": creaFra[0].valorFacturado,
                    "usuarioCreate": sessionStorage.getItem('userLogin'),
                  }
                  creaHC.push(argsAddHC)

                  
                  factFinProc = proxFact
                  // console.log(proxFact)
                  //Incrementar num fra
                  let posic1 = proxFact.indexOf("-")
                  if(posic1===-1){
                    proxFactR = parseInt(proxFact, 10)
                    proxFact = (parseInt(proxFact, 10) + 1).toString()
                  }else{
                    proxFactR = parseInt(proxFact.substr(posic1 + 1), 10)
                    proxFact = proxFact.substr(0, posic1) + '-' + (parseInt(proxFact.substr(posic1 + 1), 10) + 1).toString()
                  }
                }
                // console.log(proxFact)
                // console.log(proxFactR)
                      //  }
                ////////////////////////////////////////
                //FIN GRABAR PROCESO DE FACTURACION PARA EL CLIENTE
              })
              // }

              //Crear el registro en histclientes
              let creaHCMany = [], creaHCMany1 = []
              creaHC.forEach((elementoHC, ii) => {
                creaHCMany.push(elementoHC)
              })
              creaHCMany1.push({histcliente: creaHCMany})

              let numDocCRUD = 0, totDocCRUD = 1, argsCrud = [], crudColecc = []
              for(let iii=0; iii<totDocCRUD; iii++){
                argsCrud.push({ctrlCampo: 'NO_CRUD'})
              }
              for(let iii=0; iii<totDocCRUD; iii++){
                crudColecc.push(this.props.createHistClienteMany)
              }

              argsCrud[numDocCRUD] = creaHCMany1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.createHistClienteMany

              // console.log(crudColecc)
              // console.log(argsCrud)
              // console.log(totDocCRUD)
              await updColecc(crudColecc, argsCrud, totDocCRUD)
                    
              //VA
              // console.log(movCliMany)
              // console.log(actmovCliMany)
              // console.log(actCliMany)

              let creaFraMany1 = []
              creaFraMany1.push({facturacion: creaFraMany})

              let movCliMany1 = []
              movCliMany1.push({movcliente: movCliMany})

              let actCliMany1 = []
              actCliMany1.push({cliente: actCliMany})

              let actCliPHMany1 = []
              actCliPHMany1.push({cliente: actCliPHMany})

              let actPASFCliMany1 = []
              actPASFCliMany1.push({cliente: actPASFCliMany})

              let actmovCliMany1 = []
              actmovCliMany1.push({movcliente: actmovCliMany})

              let actCliMCMany1 = []
              actCliMCMany1.push({movcliente: actCliMCMany})

              let actMNFMany1 = []
              actMNFMany1.push({mesnofra: actMNFMany})

              // console.log(movCliMany1)
              // console.log(actCliMany1)
              // console.log(actmovCliMany1)
              // console.log(actMNFMany1)
              //Crear el cargo especial y los movcliente
              numDocCRUD = 0
              totDocCRUD = 8
              if(tieneRegMovCli&&tieneRegMovCliCC){
                // console.log("tiene movcli y movclicc")
                totDocCRUD = 9
              }else{
                if(!tieneRegMovCli&&tieneRegMovCliCC){
                  console.log("solo tiene movclicc")
                  totDocCRUD = 7
                }
              }
              argsCrud = []
              crudColecc = []
              for(let iii=0; iii<totDocCRUD; iii++){
                argsCrud.push({ctrlCampo: 'NO_CRUD'})
              }
              for(let iii=0; iii<totDocCRUD; iii++){
                if(!tieneRegMovCli&&tieneRegMovCliCC){
                  crudColecc.push(this.props.editMovCliCCMany)
                }else{
                  crudColecc.push(this.props.editMovClientesMany)
                }
              }

              argsCrud[numDocCRUD] = creaFraMany1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.createFacturacionMany
            
              numDocCRUD += 1

              argsCrud[numDocCRUD] = movCliMany1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.createMovClientesMany

              numDocCRUD += 1

              argsCrud[numDocCRUD] = actCliMany1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.editClienteMany

              numDocCRUD += 1

              argsCrud[numDocCRUD] = actMNFMany1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.editMesNoFraMany

              numDocCRUD += 1

              argsCrud[numDocCRUD] = actCliPHMany1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.editClienteMany

              numDocCRUD += 1

              argsCrud[numDocCRUD] = actPASFCliMany1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.editClienteMany

              numDocCRUD += 1

              if(tieneRegMovCliCC){
                // console.log("editMovCliCCMany")
                argsCrud[numDocCRUD] = actmovCliMany1[0]
                argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
                argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
                crudColecc[numDocCRUD] = this.props.editMovCliCCMany

                numDocCRUD += 1
              }

              if(tieneRegMovCli){
                // console.log("editMovClientesMany")

                argsCrud[numDocCRUD] = actCliMCMany1[0]
                argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
                argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
                crudColecc[numDocCRUD] = this.props.editMovClientesPHMany

                numDocCRUD += 1

                argsCrud[numDocCRUD] = actmovCliMany1[0]
                argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
                argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
                crudColecc[numDocCRUD] = this.props.editMovClientesMany
              }
              // console.log(crudColecc)
              // console.log(argsCrud)
              // console.log(totDocCRUD)
              // console.log(movCliMany)
              if(creaFraMany.length>0||movCliMany.length===1){
                // console.log(creaFraMany)
                await updColecc(crudColecc, argsCrud, totDocCRUD)
              }

              // console.log(proxFact)
              // console.log(proxFactR)
              if(proxFactR===undefined){
                factIniProc = ""
                factFinProc = ""
                proxFactR = proxFact
              }
              //Actualizar próxima factura y actualizar factura inicial y final del proceso => si hay facturas generadas
              let actColecc = []
              argsUpd = {
                "_id": this.state.argsDocum._id,
                tipoAct: "EditarProxFact",
                "proxFact": proxFactR,
              }
              actColecc.push(argsUpd)
              // console.log(argsUpd)

              argsUpd = {
                "codProcFact": codProcFact,
                "factInicial": factIniProc,
                "factFinal": factFinProc,
              }
              actColecc.push(argsUpd)

              numDocCRUD = 0
              totDocCRUD = 2
              argsCrud = []
              crudColecc = []
              for(let iii=0; iii<totDocCRUD; iii++){
                argsCrud.push({ctrlCampo: 'NO_CRUD'})
              }
              for(let iii=0; iii<totDocCRUD; iii++){
                crudColecc.push(this.props.editProcFact)
              }

              argsCrud[numDocCRUD] = actColecc[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

              crudColecc[numDocCRUD] = this.props.editRangoFact

              numDocCRUD += 1

              argsCrud[numDocCRUD] = actColecc[1]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              // console.log(argsCrud)
              // let finProceso = 0
              // finProceso = await updColecc(crudColecc, argsCrud, totDocCRUD)
              // console.log(factIniProc, factFinProc)
              // if(factIniProc!==factFinProc){

              await updColecc(crudColecc, argsCrud, totDocCRUD)

              // }

              console.log("listooooo")
              // console.log(finProceso)

              clientesFra = []
              argsBuscarCL={}
              argsBuscarCL.numDocum = 1
              if(this.props.allClientes.allClientes){
                let {data} = await this.props.allClientes.refetch(argsBuscarCL)
                clientesFra = await data.allClientes
              }
              // console.log(clientesFra)

              const argsDocum = this.state.argsDocum
              argsDocum['observaciones'] = ""
              this.setState({argsDocum});
              var observaciones = document.getElementById("observaciones");
              observaciones.value = ""

              // if(finProceso===1){
              //   this.setState({finProceso})
              // }
              // console.log(minEspera)
              setTimeout(async (minEspera) => {
                console.log("Ultimo proceso")

                //SI HAY CARGOS NEG Y SALDOCL > 0 => APLICARLOS DCTOS EN LOS MOV MAS ANTIGUOS
                // console.log(saldoCl, valorPagNeg, this.props.comoAsigCargosAlCliente)
                // if(this.props.allMovRtes.allMovRtes){
                let movimMCNeg = [], movimMCCl = []
                let argsBuscarMCNeg = `{tipo: "C", valorTotal: {$lt: 0}}`
                argsBuscarMCNeg = {tipoqry: `[{$match: ${argsBuscarMCNeg}},
                    {$project: {contrato: 1, tipo: 1, valorTotal: 1, valorPagado: 1, valorPendiente: 1,
                      diferencia: {$subtract: [ "$valorTotal", "$valorPagado" ]}}},
                    {$match: {diferencia: {$ne: 0}}},
                    {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}}]`,
                  tipoProc: "Validar cargos neg proc fact"}

                let hacerProcNeg = true
                if(hacerProcNeg){
                  // console.log(argsBuscarMCNeg)
                  let {data} = await this.props.allMovRtes.refetch(argsBuscarMCNeg)
                  movimMCNeg = await data.allMovRtes
                  console.log(movimMCNeg)
                  //La siguiente linea se hizo en el resolvers
                  // movimMCNeg = movimMCNeg.filter(elemento => elemento.valorTotal!==elemento.valorPagado)
                }
                // console.log(movimMCNeg)

              let contrato = ""

              if(hacerProcNeg){
                console.log("proceso neg")
                for(let ii=0; ii<movimMCNeg.length; ii++){
                  if(contrato!==movimMCNeg[ii].contrato){
                    contrato = movimMCNeg[ii].contrato
                    // console.log(contrato)

                    let argsBuscarCli = {tipoqry: `[{$match: {contrato: "${movimMCNeg[ii].contrato}", tipo: 'C', valorPendiente: {$gt: 0}}},
                      {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}}]`,
                      tipoProc: "Validar cargos neg proc fact"}

                    let {data} = await this.props.allMovRtes.refetch(argsBuscarCli)
                    let movimMCClTemp = await data.allMovRtes
                    // console.log(contrato, movimMCClTemp)
                    movimMCCl = movimMCCl.concat(movimMCClTemp)
                  }
                }
              }
              // console.log(contrato, movimMCCl)

              let actmovCli = [], actmovCliMany = [], actmovCliMany1 = [], listColecc = []
              contrato = ""
              // movimMCNeg.forEach((elemento1, iii) => {
              for(let iii=0; iii<movimMCNeg.length; iii++){
                let elemento1 = movimMCNeg[iii]
                let valorPagNeg = elemento1.valorTotal

                if(contrato!==elemento1.contrato){
                  contrato = elemento1.contrato
                  // console.log(contrato, movimMCCl)
                  listColecc = movimMCCl.filter(elemento => elemento.contrato===elemento1.contrato)
                  if(listColecc.length>0){
                    listColecc = listColecc.map(recpago => ({...recpago}))
                    listColecc = _.orderBy(listColecc, ['_id'], ['asc'])
                  }
                }
                // let listColecc = movimMCCl.filter(elemento => elemento.contrato===elemento1.contrato &&
                //             elemento.valorTotal!==elemento.valorPagado && elemento.valorTotal>0)
                
                if(listColecc.length>0||(listColecc.length===0&&elemento1.saldoCliente<=0)){
                  // console.log("55", elemento1)
                  // listColecc = listColecc.map(recpago => ({...recpago}))    
                  // listColecc = _.orderBy(listColecc, ['_id'], ['asc'])
                  // console.log(listColecc)
                  let argsUpd = {}
                  argsUpd = {
                    // "contrato": elemento1.contrato,
                    "_id": elemento1._id,
                    "procesado": elemento1.procesado,
                    "concepto": elemento1.concepto,
                    "numeroFra": elemento1.numeroFra,
                    "numeroRC": elemento1.numeroRC,
                    "numeroCE": elemento1.numeroCE,
                    "numeroOdeDX": elemento1.numeroOdeDX,
                    "fechaUltPago": elemento1.fechaUltPago,
                    "valorUltPago": elemento1.valorUltPago,
                    "documento": elemento1.documento,
                    "valorPagado": valorPagNeg,
                  }
                  // console.log(elemento1.contrato, elemento1.cliente[0].saldoPendiente, argsUpd)
                  actmovCli.push(argsUpd)
                  if(elemento1.cliente[0].saldoPendiente<=0){
                    // if(elemento1.saldoPendiente<=0){
                    listColecc.forEach((elemento2, ii) => {
                      argsUpd = {
                        // "contrato": elemento1.contrato,
                        "_id": elemento2._id,
                        "procesado": elemento2.procesado,
                        "concepto": elemento2.concepto,
                        "numeroFra": elemento2.numeroFra,
                        "numeroRC": elemento2.numeroRC,
                        "numeroCE": elemento2.numeroCE,
                        "numeroOdeDX": elemento2.numeroOdeDX,
                        "fechaUltPago": elemento2.fechaUltPago,
                        "valorUltPago": elemento2.valorUltPago,
                        "documento": elemento2.documento,
                        "valorPagado": elemento2.valorTotal,
                      }
                      actmovCli.push(argsUpd)
                      // console.log(elemento1.contrato, argsUpd)
                    })
                  }else{
                    // console.log(listColecc)
                    valorPagNeg = valorPagNeg * -1
                    listColecc.forEach((elemento, i) => {
                      if(elemento.valorTotal<0){
                        valorPagNeg -= elemento.valorTotal
                        listColecc[i].valorRecibido = elemento.valorTotal
                        // console.log(elemento.contrato, elemento.valorTotal, valorPagNeg)
                      }
                    })
                    listColecc.forEach((elemento, i) => {
                      // console.log(elemento.contrato, elemento.valorPagado, elemento.valorRecibido)
                      if(elemento.valorTotal>0){
                        if(valorPagNeg > elemento.valorTotal - elemento.valorPagado){
                          valorPagNeg -= (elemento.valorTotal - elemento.valorPagado)
                          listColecc[i].valorRecibido = elemento.valorTotal - elemento.valorPagado
                        }else{
                          listColecc[i].valorRecibido = valorPagNeg
                          valorPagNeg = 0
                        }
                      }
                    })
                    // console.log(listColecc)
                    listColecc.forEach((elemento2, ii) => {
                      // console.log(elemento2.contrato, elemento2)
                      if(elemento2.valorRecibido&&elemento2.valorRecibido!==0){
                        // console.log(elemento2)
                        let valPagado = 0
                        if(elemento2.valorPagado){
                          // console.log(elemento2.contrato, elemento2.valorPagado, elemento2.valorRecibido)
                          valPagado = parseInt(elemento2.valorPagado, 10) + parseInt(elemento2.valorRecibido, 10)
                        }else{
                          // console.log(elemento2.contrato, elemento2.valorRecibido)
                          valPagado = parseInt(elemento2.valorRecibido, 10)
                        }
                        argsUpd = {
                          // "contrato": elemento2.contrato,
                          "_id": elemento2._id,
                          "procesado": elemento2.procesado,
                          "concepto": elemento2.concepto,
                          "numeroFra": elemento2.numeroFra,
                          "numeroRC": elemento2.numeroRC,
                          "numeroCE": elemento2.numeroCE,
                          "numeroOdeDX": elemento2.numeroOdeDX,
                          "documento": elemento2.documento,
                          "fechaUltPago": elemento2.fechaUltPago,
                          "valorUltPago": elemento2.valorUltPago,
                          "valorPagado": valPagado,
                          "valorPendiente": elemento2.valorTotal - valPagado,
                        }
                        actmovCli.push(argsUpd)
                        // console.log(elemento2.contrato, valPagado, argsUpd)
                        listColecc[ii].valorPagado = valPagado
                        listColecc[ii].valorPendiente = elemento2.valorTotal - valPagado
                      }
                    })
                  }
                }
              }
              // })
              // console.log(actmovCli)

              actmovCli.forEach((elementoFra, ii) => {
                actmovCliMany.push(elementoFra)
              })
              actmovCliMany1.push({movcliente: actmovCliMany})

              //Actualizar BD
              numDocCRUD = 0
              // let totDocCRUD = actmovCli.length
              totDocCRUD = 1
              argsCrud = []
              crudColecc = []
              for(let iii=0; iii<totDocCRUD; iii++){
                argsCrud.push({ctrlCampo: 'NO_CRUD'})
              }
              for(let iii=0; iii<totDocCRUD; iii++){
                crudColecc.push(this.props.editMovClientesMany)
              }

              argsCrud[numDocCRUD] = actmovCliMany1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.editMovClientesMany

              if(totDocCRUD>0){
                // console.log(crudColecc)
                // console.log(argsCrud)
                await updColecc(crudColecc, argsCrud, totDocCRUD)
              }
              // }
              //FIN SI HAY CARGOS NEG Y SALDOCL > 0 => APLICARLOS DCTOS EN LOS MOV MAS ANTIGUOS

              console.timeEnd(1)

              let argsDocum = this.state.argsDocum      
              argsDocum['prefijoFact'] = ""
              argsDocum['proxFact'] = ""
              argsDocum['factInicial'] = ""
              argsDocum['factFinal'] = ""
              argsDocum['rango'] = "Seleccionar..."
              argsDocum['cicloFact'] = "Seleccionar..."
              this.setState({argsDocum});

              this.setState({finProceso: 1})

              alert("!! Proceso finalizado !!")

              this.props.allRangoFact.refetch()
              let rango = document.getElementById("miLista3");
              rango.options.selectedIndex = 0
              let cicloFact = document.getElementById("miListaCF");
              cicloFact.options.selectedIndex = 0

              this.props.allMovTodos.refetch()
              this.props.allMovTodosCC.refetch()
            }, minEspera);

            // this.setState({finProceso: 1})
          }
        }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = await document.getElementById("btnUpdDel");
        myBtn.click()
    }
  }
  
  componentDidUpdate(prevProps){
    if(this.props.argsSelDpto.codigoCiudad!==undefined&&this.props.argsSelDpto.codigoCiudad!==""){
      let miLista = document.getElementById("miLista1");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoCiudad){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreCiudad'] = "Todas..."
        argsSelDpto['codigoCiudad'] = ""
        argsSelDpto['codigoMunicipioDANE'] = ""
        argsSelDpto['codigoPostalDANE'] = ""
        argsSelDpto['codigoCiudadInterno'] = ""
        argsSelDpto['codBarrasRdo'] = ""
        argsSelDpto['nombreZona'] = ""
        this.setState({argsSelDpto})
      }
    }
  
    if(this.props.argsSelDpto!==prevProps.argsSelDpto){
      this.setState({argsSelDpto: this.props.argsSelDpto})
    }
  }

  render(){
    const {argsDocum, opciones, permiteUpdate, confirmaAct, open, errors, progresoFact, finProceso} = this.state;
    // console.log(this.props.allMovTodos.allMovTodos)
    // console.log(this.props.allClientes.allClientes)
    // console.log(this.props.allFacturacion.allFacturacion)
    // console.log(this.props.allCargoEsp.allCargoEsp)
    // console.log(this.props.allMovTodosCC.allMovTodosCC)
    // console.log(this.props.argsSelDpto, this.state.argsSelDpto, this.props.codigoCiudadUA)
    // console.log(this.props.empresa.empresaArchFE)
    if(this.props.codigoCiudadUA!=="Todas..."){
      let dpto = document.getElementById("miLista");
      if(dpto){
        dpto.options.selectedIndex = 0
      }
    }

    // let colecc = selciudad(this.props.list1, this.props.argsSelDpto, this.props.codigoCiudadUA)
    let colecc = selDirmayor(this.props.list1, this.props.argsSelDpto, this.props.codigoCiudadUA)
    let listCiu = colecc.listCiu
    let listZon = colecc.listZon
    
    const fechaHoy = new Date()
    let agnoHoy = fechaHoy.getFullYear()
    let agnoAnt = fechaHoy.getFullYear()
    let agnoSig = fechaHoy.getFullYear()

    let mesHoy = ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1))
    let mesAnt = ((fechaHoy.getMonth())<10?'0'+(fechaHoy.getMonth()):(fechaHoy.getMonth()))
    let mesSig = ((fechaHoy.getMonth()+2)<10?'0'+(fechaHoy.getMonth()+2):(fechaHoy.getMonth()+2))
    
    if(mesAnt==='00'){
      agnoAnt=fechaHoy.getFullYear()-1
      mesAnt='12'
    }

    if(mesSig.toString()==='13'){
      agnoSig=fechaHoy.getFullYear()+1
      mesSig='01'
    }

    mesHoy = agnoHoy + "-" + mesHoy
    mesAnt = agnoAnt + "-" + mesAnt
    mesSig = agnoSig + "-" + mesSig

    let mesMsg = ""
    argsDocum.mes?mesMsg=argsDocum.mes:mesMsg=mesHoy
    let mensaje = "Generar facturación para el mes " + mesMsg
    let imgIcon = "images/archivo_32.png"

    let factRet = false
    argsDocum.noFactRET==="true"?factRet=true:factRet=false

    let list = []
    if(this.props.allRangoFact.allRangoFact){
      list = this.props.allRangoFact.allRangoFact
      list = list.filter(elemento => elemento.estadoRangoFact===true)
    }

    // console.log(argsDocum.noFactRET, factRet)
// console.log(this.props.listaCF)
    return(
      <div>
          <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
              <i className="large plus yellow icon"></i>
              Generar facturación
          </button>
          <div>
                    <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
                    <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, mesMsg, list, opciones):()=>{}}>
                        <div>
                            <div className="ui two column stackable grid">
                                <div className="row container">
                                    <div className="column" style={{width: '50%'}}>
                                      <h1 style={{color: '#2C7744'}}>Generar facturación</h1>
                                      <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0em'}}>
                                          Se generan facturas solo a los clientes que no se les ha generado<br/>
                                          facturación con los criterios seleccionados en el mes a procesar
                                      </p>
                                    </div>
                                    <div className="column" style={{width: '50%'}}>
                                      <p>
                                        <span style={{background: '#7F7FD5', padding: '0.5em', color: 'white', fontSize: '1.2em'}} className='ui basic label'>
                                          Mes a facturar: &nbsp;&nbsp;
                                          <span>
                                            <input style={{color: '#302b63', fontSize: '2em', paddingright: '2.5em'}} type='month' defaultValue={mesHoy} min={mesAnt} max={mesSig} name="mes" id="mes" onChange={this.handleChange}/>
                                          </span>
                                        </span>
                                      </p>
                                    </div>
                                </div>
                            </div>
                            <hr></hr>

                            {
                              errors.length?
                                <Message negative header="Los siguientes errores:"
                                list={errors.map(error=>`${error.path}: ${error.message}`)} />
                              :
                                <div>
                                  {/* <hr></hr> */}
                                  <ProcesoFact styles={this.props.styles} progresoFact={progresoFact} finProceso={finProceso}/>
                                </div>
                            }

                            {factRet?
                              <div>
                                {/* <h4 style={{color: '#2C7744'}}>NO SE VA A FACTURAR clientes en estado RETIRADO que al procesar para facturar queden con saldo menor o igual a cero</h4> */}
                                <h4 style={{color: '#2C7744'}}>NO SE VA A FACTURAR clientes en estado RETIRADO que queden con saldo menor o igual a cero</h4>
                                <hr></hr>
                                <hr></hr>
                              </div>
                            :
                              <div>
                                <hr></hr>
                              </div>
                            }
                            {this.props.empresa.empresaArchFE!=="supercablebq" &&
                              <div>
                                <h4 style={{color: '#2C7744'}}>NO SE VA A FACTURAR clientes con OS ABIERTA que tengan marcación de NO FACTURAR, que vayan a quedar DESCONECTADO, SUSPENDIDO o RETIRADO (SI se facturan los cargos adicionales)</h4>
                                <hr></hr>
                                <hr></hr>
                              </div>
                            }

                            {/* <Form.Field>
                              <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' name="checkNoFactMPF" checked={argsDocum.checkNoFactMPF} onChange={this.handleChange}/>
                                &nbsp;&nbsp;No facturar cargos de meses posteriores al de facturación
                              </p>
                            </Form.Field>
                            <hr></hr> */}


                            <div className="ui four column stackable grid">
                                <div className="row container">
                                  <div className="column" style={{width: '25%'}}>
                                    <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Fecha factura
                                    </p>
                                    <Form.Field>
                                      <input style={this.props.styles.input} type='date' name="fechaFact" id="fechaFact" value={argsDocum.fechaFact} onChange={this.handleChange}/>
                                    </Form.Field>
                                  </div>
                                  <div className="column" style={{width: '25%'}}>
                                    <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Rango
                                    </p>
                                    <Form.Field>
                                      <ListaRango styles={this.props.styles} list={list} handleChange={this.handleChange} />
                                    </Form.Field>
                                  </div>
                                  <div className="column" style={{width: '10%'}}>
                                    <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Prefijo
                                    </p>
                                    <Form.Field>
                                      <input style={this.props.styles.input} autoComplete="off" name="prefijoFact" id="prefijoFact" value={argsDocum.prefijoFact} onChange={this.handleChange} placeholder='Prefijo'/>
                                    </Form.Field>
                                  </div>
                                  <div className="column" style={{width: '15%'}}>
                                    <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Próx fra
                                    </p>
                                    <Form.Field>
                                      <input style={this.props.styles.input} autoComplete="off" name="proxFact" id="proxFact" value={argsDocum.proxFact} onChange={this.handleChange} placeholder='Próxima factura'/>
                                    </Form.Field>
                                  </div>
                                  <div className="column" style={{width: '25%'}}>
                                    <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Pague Hasta
                                    </p>
                                    <Form.Field>
                                      <input style={this.props.styles.input} type='date' name="pagueHasta" id="pagueHasta" value={argsDocum.pagueHasta} onChange={this.handleChange}/>
                                    </Form.Field>
                                  </div>
                                </div>
                            </div>
                            <hr></hr>
                            <div className="ui two column stackable grid">
                              <div className="row container">
                                <div className="column" style={{width: '50%'}}>
                                  <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                    Departamento
                                  </p>
                                  <Form.Field>
                                    <ListaDe list={this.props.list1} styles={this.props.styles}
                                        handleLista={this.props.handleLista} codigoCiudadUA={this.props.codigoCiudadUA}
                                        codigoDptoUA={this.props.codigoDptoUA}/>
                                  </Form.Field>
                                </div>
                                <div className="column" style={{width: '50%'}}>
                                  <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                    Ciudad
                                  </p>
                                  <Form.Field>
                                    <ListaCi list={listCiu} styles={this.props.styles}
                                      handleLista1={this.props.handleLista1} argsSelDpto={this.props.argsSelDpto}
                                      codigoCiudadUA={this.props.codigoCiudadUA}/>
                                  </Form.Field>
                                </div>
                              </div>
                            </div>
                            {this.props.empresa.empresaArchFE==="sinergy" &&
                              <div>
                                <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                  Zona
                                </p>
                                <Form.Field>
                                <ListaZo list={listZon} styles={this.props.styles}
                                  handleLista2={this.props.handleLista2} argsSelDpto={this.props.argsSelDpto}/>
                                </Form.Field>
                              </div>
                            }
                            <hr></hr>
                            <div className="ui two column stackable grid">
                              <div className="row container">
                                <div className="column" style={{width: '50%'}}>
                                  <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                    Clase
                                  </p>
                                  <Form.Field>
                                    <Lista styles={this.props.styles} list={this.props.list2} handleLista3={this.props.handleLista3}  argsSelDpto={this.props.argsSelDpto}/>
                                  </Form.Field>
                                </div>
                                <div className="column" style={{width: '50%'}}>
                                  <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                    Ciclo de facturación
                                  </p>
                                  <Form.Field>
                                    <ListaCF styles={this.props.styles} list={this.props.listaCF} handleChange={this.handleChange}/>
                                  </Form.Field>
                                </div>
                              </div>
                            </div>

                            {/* <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                              Clase
                            </p>
                            <Form.Field>
                              <Lista styles={this.props.styles} list={this.props.list2} handleLista3={this.props.handleLista3}  argsSelDpto={this.props.argsSelDpto}/>
                            </Form.Field> */}
                            <hr></hr>
                            <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                              Observaciones
                            </p>
                            <Form.Field>
                              <input style={this.props.styles.input} autoComplete="off" name="observaciones" id="observaciones" onChange={this.handleChange} placeholder='Observciones'/>
                            </Form.Field>
                            <hr></hr>

                            <fieldset><legend style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;&nbsp;&nbsp;Imagen a imprimir en la parte inferior de la factura&nbsp;&nbsp;&nbsp;</legend>
                              <div className="ui two column stackable grid">
                                <div className="row container">
                                  <div className="column" style={{width: '50%'}}>
                                    <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="Imagen 1" defaultChecked="true" onChange={this.handleChange}></input>
                                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Imagen 1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                                  </div>
                                  <div className="column" style={{width: '50%'}}>
                                    <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="Imagen 2" onChange={this.handleChange}></input>
                                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Imagen 2</label>
                                  </div>
                                </div>
                              </div>

                              <div className="ui two column stackable grid">
                                <div className="row container">
                                  <div className="column" style={{width: '50%'}}>
                                    <img width="354" height="141" src="images/logoclienteinf.jpeg" alt="imagen1"></img>
                                  </div>
                                  <div className="column" style={{width: '50%'}}>
                                    <img width="354" height="141" src="images/logoclienteinf2.jpeg" alt="imagen2"></img>
                                  </div>
                                </div>
                              </div>
                            </fieldset>

                            <hr></hr>

                            <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                        </div>
                        {/* {
                          errors.length?
                                    <Message negative header="Los siguientes errores:"
                                    list={errors.map(error=>`${error.path}: ${error.message}`)} />
                                      :
                                      <ProcesoFact styles={this.props.styles} progresoFact={progresoFact} finProceso={finProceso}/>
                        } */}

                      </Form>
                    </div>
                </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: {numDocum: 1}}}}),
  graphql(queries.mutation.createProcFact, {name:'createProcFact'}),
  graphql(queries.mutation.createFacturacion, {name:'createFacturacion'}),
  graphql(queries.mutation.editFacturacionUpdDoc, {name:'editFacturacionUpdDoc'}),
  graphql(queries.mutation.editRangoFact, {name:'editRangoFact'}),
  graphql(queries.mutation.editProcFact, {name:'editProcFact'}),

  graphql(queries.query.allRangoFact, {name:'allRangoFact', options: (props) => {return {variables: {}}}}),

  graphql(queries.mutation.createHistClienteMany, {name:'createHistClienteMany'}),

  graphql(queries.query.allMovTodos, {name:'allMovTodos', options: (props) => {return {variables: argsBuscarMC}}}),
  graphql(queries.mutation.createMovClientes, {name:'createMovClientes'}),
  graphql(queries.mutation.editCliente, {name:'editCliente'}),
  graphql(queries.mutation.editMovClientesPHMany, {name:'editMovClientesPHMany'}),
  graphql(queries.query.allMovTodosCC, {name:'allMovTodosCC', options: (props) => {return {variables: argsBuscarMC}}}),
  graphql(queries.query.allMovTodosCC, {name:'allMovTodosCC1', options: (props) => {return {variables: argsBuscarCCF}}}),

  graphql(queries.query.allServicios, {name:'allServicios', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allFacturacion, {name:'allFacturacion', options: (props) => {return {variables: {agno: agnoHoy, mes: mesHoy}}}}),
  graphql(queries.query.allCargoEsp, {name:'allCargoEsp', options: (props) => {return {variables: {agno: agnoHoy, mes: mesHoy}}}}),

  graphql(queries.query.allFactRtes, {name:'allFactRtes', options: (props) => {return {variables: {tipoqry: `[{$match: {fechaFact: new Date("2018-04-07")}}]`}}}}),
  
  graphql(queries.mutation.createFacturacionMany, {name:'createFacturacionMany'}),
  graphql(queries.mutation.createMovClientesMany, {name:'createMovClientesMany'}),
  graphql(queries.mutation.editClienteMany, {name:'editClienteMany'}),
  graphql(queries.mutation.editMovClientesMany, {name:'editMovClientesMany'}),
  graphql(queries.mutation.editMovCliCCMany, {name:'editMovCliCCMany'}),

  graphql(queries.query.allMovRtes, {name:'allMovRtes', options: (props) => {return {variables: argsBuscarMCNeg}}}),
  graphql(queries.query.allMovClientes, {name:'allMovClientes', options: (props) => {return {variables: {agno: '9999'}}}}),

  graphql(queries.query.allMesNoFra, {name:'allMesNoFra', options: (props) => {return {variables: {procesado: "N"}}}}),
  graphql(queries.mutation.editMesNoFraMany, {name:'editMesNoFraMany'}),


  graphql(queries.mutation.fecha, {name:'fecha'}),
  )(FactProcFact2)
